// import React, {
//   useState,
//   useEffect,
//   useContext,
//   useCallback,
//   useMemo,
// } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Paper,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   Autocomplete,
//   Grid,
//   Divider,
//   Alert,
//   IconButton,
//   Snackbar,
//   Chip,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   DialogContentText,
//   Collapse,
//   InputAdornment,
//   Tooltip,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Delete as DeleteIcon,
//   Save as SaveIcon,
//   Print as PrintIcon,
//   NoteAdd as NewIcon,
//   DeleteForever as DeleteForeverIcon,
//   AddCircleOutline as AddCircleIcon,
//   Person as PersonIcon,
//   Visibility as VisibilityIcon,
//   Edit as EditIcon,
//   Search as SearchIcon,
//   LocationOn as LocationOnIcon,
//   Phone as PhoneIcon,
//   Lock as LockIcon,
//   LockOpen as LockOpenIcon,
//   ArrowBack as ArrowBackIcon,
//   Warning as WarningIcon,
// } from "@mui/icons-material";
// import { AutoTaskAuthContext } from "../../Context/AutoTaskContext";
// import axios from "axios";
// import debounce from "lodash/debounce";
// import { Preferences } from "@capacitor/preferences";
// import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
// import HouseIcon from "@mui/icons-material/House";

// // ==================== CONSTANTS ====================
// const SESSION_KEY = "accountEntry_headerState";

// // ==================== UTILITY FUNCTIONS ====================
// const formatCurrency = (amount) => {
//   return new Intl.NumberFormat("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   }).format(amount || 0);
// };

// const getBalanceDisplay = (balance, balanceType = "DEBIT") => {
//   const abs = formatCurrency(Math.abs(balance));

//   if (balance === 0) return { text: `₹0.00`, color: "inherit" };

//   // If balance is positive, show the balance type from API
//   // If balance is negative, show opposite type
//   const displayType =
//     balance >= 0 ? balanceType : balanceType === "DEBIT" ? "CREDIT" : "DEBIT";
//   const displayText = displayType === "CREDIT" ? "Cr" : "Db";
//   const displayColor = displayType === "CREDIT" ? "#16a34a" : "#dc2626";

//   return { text: `₹${abs} ${displayText}`, color: displayColor };
// };

// const getTodayDate = () => {
//   return new Date().toISOString().split("T")[0];
// };

// // ==================== SESSION STORAGE HELPERS ====================
// const readHeaderFromSession = () => {
//   try {
//     const raw = sessionStorage.getItem(SESSION_KEY);
//     return raw ? JSON.parse(raw) : null;
//   } catch {
//     return null;
//   }
// };

// const writeHeaderToSession = (
//   voucherData,
//   accountCodeInput,
//   accountInputValue,
//   selectedAccount = null,
// ) => {
//   try {
//     sessionStorage.setItem(
//       SESSION_KEY,
//       JSON.stringify({
//         voucherDate: voucherData.voucherDate,
//         voucherType: voucherData.voucherType,
//         voucherNo: voucherData.voucherNo,
//         narration: voucherData.narration,
//         contraBank: voucherData.contraBank,
//         accountCodeInput,
//         accountInputValue,
//         selectedAccount,
//       }),
//     );
//   } catch {
//     // sessionStorage write failure is non-fatal
//   }
// };

// const clearHeaderSession = () => {
//   try {
//     sessionStorage.removeItem(SESSION_KEY);
//   } catch {
//     // ignore
//   }
// };

// // ==================== MAIN COMPONENT ====================
// const AccountEntry = () => {
//   // const defaultFY = Preferences.get({ key: defaultFY });

//   const { userInfo, defaultFY, defaultFYId } =
//     useContext(AutoTaskAuthContext) || {};

//   const user_id = userInfo.id;
//   const store_id = userInfo?.store_id || 0;

//   const location = useLocation();
//   const navigate = useNavigate();

//   const isFromLedger = location.state?.fromLedger === true;

//   const savedSession = readHeaderFromSession();

//   const [voucherData, setVoucherData] = useState({
//     voucherDate: savedSession?.voucherDate ?? getTodayDate(),
//     voucherType: savedSession?.voucherType ?? "PAYMENT",
//     voucherNo: savedSession?.voucherNo ?? "",
//     narration: savedSession?.narration ?? "",
//     contraBank: savedSession?.contraBank ?? null,
//   });

//   const [currentLine, setCurrentLine] = useState({
//     entryType: savedSession?.voucherType === "RECEIPT" ? "CREDIT" : "DEBIT",
//     account: savedSession?.selectedAccount ?? null,
//     amount: "",
//     costCentre: null,
//     narration: "",
//     customer: null,
//   });

//   const [partyDetails, setPartyDetails] = useState({
//     code: "",
//     mobile: "",
//     name: "",
//     address: "",
//     balance: 0,
//     balanceType: "DEBIT",
//   });

//   const [voucherLines, setVoucherLines] = useState([]);
//   console.log(voucherLines);
//   const [errors, setErrors] = useState({});
//   const [accountCodeInput, setAccountCodeInput] = useState(
//     savedSession?.accountCodeInput ?? "",
//   );
//   const [accountInputValue, setAccountInputValue] = useState(
//     savedSession?.accountInputValue ?? "",
//   );
//   const [voucherNoInput, setVoucherNoInput] = useState(
//     savedSession?.voucherNo ?? "",
//   );

//   const [isHeaderLocked, setIsHeaderLocked] = useState(!!savedSession);

//   // ── Edit mode states ──
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [loadingVoucher, setLoadingVoucher] = useState(false);
//   const [originalVoucherNo, setOriginalVoucherNo] = useState(null);
//   const [editingLineIndex, setEditingLineIndex] = useState(null);

//   const [confirmDialog, setConfirmDialog] = useState({
//     open: false,
//     field: null,
//     newValue: null,
//   });

//   // ── Delete confirmation dialog ──
//   const [deleteDialog, setDeleteDialog] = useState({
//     open: false,
//     mode: null,
//     deleting: false,
//   });

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const [accounts, setAccounts] = useState([]);
//   const [bankAccounts, setBankAccounts] = useState([]);
//   const [costCenters, setCostCenters] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [accountBalance, setAccountBalance] = useState(0);
//   const [accountBalanceType, setAccountBalanceType] = useState("DEBIT");

//   // ── Balance for the selected contra bank ──
//   const [contraBalance, setContraBalance] = useState(0);
//   const [contraBalanceType, setContraBalanceType] = useState("DEBIT");

//   const [customerOptions, setCustomerOptions] = useState([]);
//   const [loadingCustomers, setLoadingCustomers] = useState(false);
//   const [showCustomerField, setShowCustomerField] = useState(
//     !!savedSession?.selectedAccount?.isParty,
//   );
//   const [customerInputValue, setCustomerInputValue] = useState("");

//   // ==================== SNACKBAR HELPER ====================
//   const showSnackbar = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // ==================== CLEAR SESSION ON NAVIGATION ====================
//   useEffect(() => {
//     return () => {
//       clearHeaderSession();
//     };
//   }, []);

//   // ==================== HANDLE NEWLY CREATED ACCOUNT ====================
//   useEffect(() => {
//     if (location.state?.newAccount) {
//       const newAccount = location.state.newAccount;
//       setCurrentLine((prev) => ({ ...prev, account: newAccount }));
//       setAccountCodeInput(newAccount.account_code || "");
//       setAccountInputValue(newAccount.account_name || "");
//       fetchAccounts();
//       window.history.replaceState({}, document.title);
//       showSnackbar("✓ Account created and selected!");
//     }
//   }, [location.state]);

//   // ==================== HANDLE INCOMING VOUCHER_NO FROM NAVIGATION ====================
//   useEffect(() => {
//     if (location.state?.voucher_no) {
//       const voucherNo = location.state.voucher_no;
//       setVoucherNoInput(voucherNo);
//       fetchVoucherData(voucherNo);
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state]);

//   // ==================== API CALLS ====================
//   useEffect(() => {
//     if (store_id !== null && store_id !== undefined) {
//       fetchAccounts();
//       fetchCostCenters();
//       if (!savedSession && !location.state?.voucher_no) {
//         fetchVoucherNumber("PAYMENT");
//       }
//     }
//   }, [store_id]);

//   useEffect(() => {
//     if (accounts.length > 0 && currentLine.account) {
//       fetchBalance(currentLine.account.account_id, "account", "account");
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [accounts]);

//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/api/accounts/accounts/${store_id}/accounts-only`,
//       );
//       if (response.data.success) {
//         const allAccounts = response.data.data.map((acc) =>
//           acc.account_name?.toLowerCase() === "party"
//             ? { ...acc, isParty: true }
//             : acc,
//         );
//         setAccounts(allAccounts);
//         const banks = allAccounts.filter((acc) => acc.is_bank_account === true);
//         setBankAccounts(banks);
//       }
//     } catch (error) {
//       console.error("Error fetching accounts:", error);
//       showSnackbar("Error loading accounts", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCostCenters = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/api/accounts/cost-centers/${store_id}`,
//       );
//       if (response.data.success) {
//         setCostCenters(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching cost centers:", error);
//     }
//   };

//   const fetchVoucherNumber = async (voucherType) => {
//     try {
//       setLoadingVoucher(true);
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/api/accounts/generate-voucher/${voucherType}/${store_id}/${defaultFY}`,
//       );
//       if (response.data.success) {
//         const newNo = response.data.data.voucher_number;
//         setVoucherData((prev) => ({ ...prev, voucherNo: newNo }));
//         setVoucherNoInput(newNo);
//         return newNo;
//       }
//     } catch (error) {
//       console.error("Error generating voucher number:", error);
//       showSnackbar("Error generating voucher number", "error");
//     } finally {
//       setLoadingVoucher(false);
//     }
//     return "";
//   };

//   const fetchCustomerByPartyCode = async (code) => {
//     if (!code.trim()) return;
//     try {
//       setLoadingCustomers(true);
//       const response = await axios.get(
//         `${
//           process.env.REACT_APP_API_BASE_URL
//         }/api/travel/customers/by-party-code/${store_id}/${code.trim()}`,
//       );
//       if (response.data.success) {
//         const matched = response.data.data;
//         handleLineChange("customer", matched);
//         setCustomerInputValue(matched.name || "");
//         setPartyDetails({
//           code: matched.party_code || "",
//           mobile: matched.mobile || "",
//           name: matched.name || "",
//           address: matched.address || "",
//           balance: matched.balance || 0,
//           balanceType: matched.balanceType || "DEBIT",
//         });
//         fetchBalance(matched.id, "customer");
//         setErrors((prev) => ({ ...prev, customer: null }));
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         setPartyDetails({
//           code: "",
//           mobile: "",
//           name: "",
//           address: "",
//           balance: 0,
//           balanceType: "DEBIT",
//         });
//         setCustomerInputValue("");
//         handleLineChange("customer", null);
//         showSnackbar("No customer found with this party code", "warning");
//       } else {
//         showSnackbar("Error fetching customer", "error");
//       }
//     } finally {
//       setLoadingCustomers(false);
//     }
//   };

//   const fetchCustomersByMobile = useCallback(
//     debounce(async (searchTerm) => {
//       if (!searchTerm || searchTerm.trim().length < 3) {
//         setCustomerOptions([]);
//         return;
//       }
//       try {
//         setLoadingCustomers(true);
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/api/travel/customers/search/${store_id}`,
//           { params: { q: searchTerm.trim(), limit: 50, numericOnly: true } },
//         );
//         if (response.data.success) {
//           setCustomerOptions(response.data.data || []);
//         } else {
//           setCustomerOptions([]);
//         }
//       } catch (error) {
//         console.error("Error searching customers by mobile:", error);
//         setCustomerOptions([]);
//       } finally {
//         setLoadingCustomers(false);
//       }
//     }, 300),
//     [store_id],
//   );

//   const fetchBalance = useCallback(
//     async (id, type, target = "party") => {
//       if (!id) return;
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/api/accounts/balance/${id}/${defaultFYId}`,
//           { params: { type } },
//         );
//         if (response.data.success) {
//           const balance = response.data.data.closing_balance;
//           const balanceType =
//             response.data.data.closing_balance_type || "DEBIT";

//           if (target === "account") {
//             setAccountBalance(balance);
//             setAccountBalanceType(balanceType);
//           } else if (target === "contra") {
//             setContraBalance(balance);
//             setContraBalanceType(balanceType);
//           } else {
//             setPartyDetails((prev) => ({ ...prev, balance, balanceType }));
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching balance:", error);
//       }
//     },
//     [defaultFYId],
//   );

//   useEffect(() => {
//     return () => {
//       fetchCustomersByMobile.cancel();
//     };
//   }, [fetchCustomersByMobile]);

//   const searchCustomers = useCallback(
//     debounce(async (searchTerm) => {
//       if (!searchTerm || searchTerm.trim().length < 2) {
//         setCustomerOptions([]);
//         return;
//       }
//       if (store_id === null || store_id === undefined) return;
//       try {
//         setLoadingCustomers(true);
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/api/travel/customers/search/${store_id}`,
//           { params: { q: searchTerm.trim(), limit: 50 } },
//         );
//         if (response.data.success) {
//           setCustomerOptions(response.data.data || []);
//         } else {
//           setCustomerOptions([]);
//         }
//       } catch (error) {
//         console.error("Error searching customers:", error);
//         setCustomerOptions([]);
//         showSnackbar("Error searching customers", "error");
//       } finally {
//         setLoadingCustomers(false);
//       }
//     }, 300),
//     [store_id],
//   );

//   useEffect(() => {
//     return () => {
//       searchCustomers.cancel();
//     };
//   }, [searchCustomers]);

//   // ==================== FETCH VOUCHER FOR EDITING ====================
//   const fetchVoucherData = async (voucherNumber) => {
//     if (!voucherNumber.trim()) {
//       showSnackbar("Please enter a voucher number", "warning");
//       return;
//     }

//     try {
//       setLoadingVoucher(true);

//       let currentAccounts = accounts;
//       let currentCostCenters = costCenters;
//       let currentBankAccounts = bankAccounts;

//       if (accounts.length === 0) {
//         const accRes = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/api/accounts/accounts/${store_id}/accounts-only`,
//         );
//         if (accRes.data.success) {
//           currentAccounts = accRes.data.data.map((acc) =>
//             acc.account_name?.toLowerCase() === "party"
//               ? { ...acc, isParty: true }
//               : acc,
//           );
//           setAccounts(currentAccounts);
//           currentBankAccounts = currentAccounts.filter(
//             (acc) => acc.is_bank_account === true,
//           );
//           setBankAccounts(currentBankAccounts);
//         }
//       }

//       if (costCenters.length === 0) {
//         const ccRes = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/api/accounts/cost-centers/${store_id}`,
//         );
//         if (ccRes.data.success) {
//           currentCostCenters = ccRes.data.data;
//           setCostCenters(currentCostCenters);
//         }
//       }

//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/api/accounts/ledger-by-voucherno`,
//         {
//           params: {
//             voucherNumber: voucherNumber,
//           },
//         },
//       );

//       if (response.data.success && response.data.data.length > 0) {
//         const entries = response.data.data;
//         const firstEntry = entries[0];

//         const voucherDate = firstEntry.voucherdate
//           ? firstEntry.voucherdate.split("T")[0]
//           : getTodayDate();

//         const contraEntry = entries.find(
//           (entry) =>
//             entry.is_contra_entry === true || entry.is_contra_entry === 1,
//         );
//         const contraBankAccount = contraEntry
//           ? currentBankAccounts.find(
//               (acc) => acc.account_id === parseInt(contraEntry.account),
//             ) || null
//           : null;

//         setVoucherData({
//           voucherDate,
//           voucherType: firstEntry.voucher_type || "JOURNAL",
//           voucherNo: firstEntry.vouchernumber,
//           narration: firstEntry.narration || "",
//           contraBank: contraBankAccount,
//         });
//         setVoucherNoInput(firstEntry.vouchernumber);

//         if (contraBankAccount?.account_id) {
//           fetchBalance(contraBankAccount.account_id, "account", "contra");
//         } else {
//           setContraBalance(0);
//           setContraBalanceType("DEBIT");
//         }

//         const transformedLines = entries.map((entry, index) => {
//           const account = currentAccounts.find(
//             (acc) => acc.account_id === parseInt(entry.account),
//           );
//           const costCentreIdFromAPI = entry.costcentreid || null;
//           const costCentre = costCentreIdFromAPI
//             ? currentCostCenters.find((cc) => cc.id === costCentreIdFromAPI)
//             : null;
//           const debitAmt = parseFloat(entry.debit_amount || 0);
//           const creditAmt = parseFloat(entry.credit_amount || 0);
//           const isDebit = debitAmt > 0;
//           const entryType = isDebit ? "DEBIT" : "CREDIT";
//           const amount = isDebit ? debitAmt : creditAmt;
//           const isContra =
//             entry.is_contra_entry === true || entry.is_contra_entry === 1;

//           return {
//             slNo: index + 1,
//             accountId: parseInt(entry.account),
//             accountCode: account?.account_code || "",
//             accountName: account?.account_name || `Account #${entry.account}`,
//             entryType,
//             amount: amount.toFixed(2),
//             costCentre: costCentre || null,
//             costCentreId: costCentreIdFromAPI,
//             costCentreName: costCentre?.name || "",
//             costCentreNameFromDropdown: null,
//             narration: entry.vnarration || entry.narration || "",
//             isContraEntry: isContra,
//             customerId: entry.party_account || null,
//             customerName: null,
//             customerMobile: null,
//           };
//         });

//         setVoucherLines(transformedLines);

//         const nonContraLines = transformedLines.filter((l) => !l.isContraEntry);
//         const partyLine = nonContraLines.find((l) => l.customerId);
//         const nonPartyLine = nonContraLines.find((l) => !l.customerId);
//         const formLine = partyLine || nonPartyLine || nonContraLines[0];
//         if (formLine) {
//           const formAccount = currentAccounts.find(
//             (acc) => acc.account_id === formLine.accountId,
//           );
//           if (formAccount) {
//             setCurrentLine((prev) => ({
//               ...prev,
//               account: formAccount,
//               entryType: formLine.entryType,
//               customer: null,
//             }));
//             setAccountCodeInput(formAccount.account_code || "");
//             setAccountInputValue(
//               `${
//                 formAccount.account_code ? formAccount.account_code + " - " : ""
//               }${formAccount.account_name}`,
//             );
//             if (formAccount.isParty) {
//               setShowCustomerField(true);
//               fetchBalance(formAccount.account_id, "account", "account");
//             } else {
//               setShowCustomerField(false);
//               fetchBalance(formAccount.account_id, "account", "account");
//             }
//           }
//         }

//         setIsEditMode(true);
//         setOriginalVoucherNo(voucherNumber.trim());
//         setIsHeaderLocked(true);

//         showSnackbar(
//           `✓ Voucher ${voucherNumber} loaded for editing`,
//           "success",
//         );

//         for (const line of nonContraLines) {
//           if (line.customerId) {
//             try {
//               const custResponse = await axios.get(
//                 `${process.env.REACT_APP_API_BASE_URL}/api/travel/customers/${line.customerId}`,
//               );
//               if (custResponse.data.success) {
//                 const customer = custResponse.data.data;
//                 setVoucherLines((prev) =>
//                   prev.map((l) =>
//                     l.customerId === line.customerId
//                       ? {
//                           ...l,
//                           customerName: customer.name,
//                           customerMobile: customer.mobile,
//                         }
//                       : l,
//                   ),
//                 );

//                 if (formLine && line.accountId === formLine.accountId) {
//                   const customerObj = {
//                     id: customer.id,
//                     name: customer.name,
//                     mobile: customer.mobile,
//                     party_code: customer.party_code || "",
//                     address: customer.address || "",
//                     balance: customer.balance || 0,
//                   };
//                   setCurrentLine((prev) => ({
//                     ...prev,
//                     customer: customerObj,
//                   }));
//                   setCustomerInputValue(customer.name || "");
//                   setPartyDetails({
//                     code: customer.party_code || "",
//                     mobile: customer.mobile || "",
//                     name: customer.name || "",
//                     address: customer.address || "",
//                     balance: customer.balance || 0,
//                     balanceType: customer.balanceType || "DEBIT",
//                   });
//                   setShowCustomerField(true);
//                   fetchBalance(customer.id, "customer", "party");
//                 }
//               }
//             } catch (error) {
//               console.error("Error fetching customer:", error);
//             }
//           }
//         }
//       } else {
//         showSnackbar("No voucher found with this number", "warning");
//       }
//     } catch (error) {
//       console.error("Error fetching voucher:", error);
//       if (error.response?.status === 404) {
//         showSnackbar("Voucher not found", "error");
//       } else {
//         showSnackbar("Error loading voucher", "error");
//       }
//     } finally {
//       setLoadingVoucher(false);
//     }
//   };

//   // ==================== COMPUTED VALUES ====================
//   const totalDebit = voucherLines
//     .filter((line) => line.entryType === "DEBIT")
//     .reduce((sum, line) => sum + parseFloat(line.amount || 0), 0);

//   const totalCredit = voucherLines
//     .filter((line) => line.entryType === "CREDIT")
//     .reduce((sum, line) => sum + parseFloat(line.amount || 0), 0);

//   const difference = totalDebit - totalCredit;
//   const isBalanced = Math.abs(difference) < 0.01;

//   const accountOptionsWithParty = accounts;

//   // ==================== HANDLERS ====================
//   useEffect(() => {
//     writeHeaderToSession(
//       voucherData,
//       accountCodeInput,
//       accountInputValue,
//       currentLine.account,
//     );
//   }, [voucherData, accountCodeInput, accountInputValue, currentLine.account]);

//   const handleVoucherChange = (field, value) => {
//     if (
//       voucherLines.length > 0 &&
//       (field === "voucherType" || field === "contraBank")
//     ) {
//       setConfirmDialog({ open: true, field, newValue: value });
//       return;
//     }
//     applyVoucherChange(field, value);
//   };

//   const applyVoucherChange = (field, value) => {
//     setVoucherData((prev) => {
//       const updates = { ...prev, [field]: value };
//       if (field === "voucherType") {
//         updates.voucherNo = "";
//         setVoucherNoInput("");
//         if (value === "PAYMENT") {
//           setCurrentLine((prev) => ({ ...prev, entryType: "DEBIT" }));
//         } else if (value === "RECEIPT") {
//           setCurrentLine((prev) => ({ ...prev, entryType: "CREDIT" }));
//         }
//         fetchVoucherNumber(value);
//       }
//       if (field === "contraBank") {
//         if (value?.account_id) {
//           fetchBalance(value.account_id, "account", "contra");
//         } else {
//           setContraBalance(0);
//           setContraBalanceType("DEBIT");
//         }
//       }
//       return updates;
//     });
//   };

//   const handleConfirmDialogClose = (confirmed) => {
//     if (confirmed && confirmDialog.field) {
//       setVoucherLines([]);
//       applyVoucherChange(confirmDialog.field, confirmDialog.newValue);
//       showSnackbar("Entries cleared. Voucher settings updated.", "info");
//     }
//     setConfirmDialog({ open: false, field: null, newValue: null });
//   };

//   const handleLineChange = (field, value) => {
//     setCurrentLine((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleAccountSelect = (newValue) => {
//     if (!newValue) {
//       setAccountBalance(0);
//       setAccountBalanceType("DEBIT");
//     }
//     handleLineChange("account", newValue);
//     setAccountCodeInput(newValue?.account_code || "");
//     setCurrentLine((prev) => ({ ...prev, costCentre: null }));

//     if (newValue?.isParty) {
//       setShowCustomerField(true);
//       setCustomerInputValue("");
//       setCustomerOptions([]);
//       setPartyDetails({
//         code: "",
//         mobile: "",
//         name: "",
//         address: "",
//         balance: 0,
//         balanceType: "DEBIT",
//       });
//       handleLineChange("customer", null);
//       setAccountBalance(0);
//       setAccountBalanceType("DEBIT");
//       if (newValue?.account_id)
//         fetchBalance(newValue.account_id, "account", "account");
//     } else {
//       setShowCustomerField(false);
//       setCustomerInputValue("");
//       setCustomerOptions([]);
//       setPartyDetails({
//         code: "",
//         mobile: "",
//         name: "",
//         address: "",
//         balance: 0,
//         balanceType: "DEBIT",
//       });
//       handleLineChange("customer", null);
//       setAccountBalance(0);
//       setAccountBalanceType("DEBIT");
//       if (newValue?.account_id)
//         fetchBalance(newValue.account_id, "account", "account");
//     }
//   };

//   const validateCurrentLine = () => {
//     const newErrors = {};
//     if (!currentLine.account) newErrors.account = "Select account";
//     if (currentLine.account?.isParty && !currentLine.customer)
//       newErrors.customer = "Select customer";
//     if (!currentLine.amount || parseFloat(currentLine.amount) <= 0)
//       newErrors.amount = "Amount > 0";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleRowClick = (line, index) => {
//     if (line.isContraEntry) return;
//     const account = accounts.find((acc) => acc.account_id === line.accountId);
//     if (!account) return;

//     setCurrentLine({
//       entryType: line.entryType,
//       account,
//       amount: parseFloat(line.amount).toString(),
//       costCentre: line.costCentre || null,
//       narration: line.narration || "",
//       customer: line.customerId
//         ? {
//             id: line.customerId,
//             name: line.customerName || "",
//             mobile: line.customerMobile || "",
//             party_code: partyDetails.code || "",
//             address: partyDetails.address || "",
//           }
//         : null,
//     });

//     setAccountCodeInput(account.account_code || "");
//     setAccountInputValue(
//       `${account.account_code ? account.account_code + " - " : ""}${
//         account.account_name
//       }`,
//     );

//     if (account.isParty && line.customerId) {
//       setShowCustomerField(true);
//       setCustomerInputValue(line.customerName || "");
//       setPartyDetails((prev) => ({
//         ...prev,
//         name: line.customerName || "",
//         mobile: line.customerMobile || "",
//         code: prev.code || "",
//         address: prev.address || "",
//       }));
//       fetchBalance(line.customerId, "customer", "party");
//       fetchBalance(account.account_id, "account", "account");
//     } else {
//       setShowCustomerField(false);
//       setCustomerInputValue("");
//       fetchBalance(account.account_id, "account", "account");
//     }

//     setEditingLineIndex(index);
//     setErrors({});
//   };

//   const addLineToGrid = () => {
//     if (!validateCurrentLine()) {
//       showSnackbar("Please fix the errors", "error");
//       return;
//     }

//     if (editingLineIndex !== null) {
//       setVoucherLines((prev) => {
//         const updated = prev.map((line, i) => {
//           if (i === editingLineIndex) {
//             return {
//               ...line,
//               accountId: currentLine.account.account_id,
//               accountCode: currentLine.account.account_code || "",
//               accountName: currentLine.account.account_name,
//               entryType: currentLine.entryType,
//               amount: parseFloat(currentLine.amount).toFixed(2),
//               costCentre: currentLine.costCentre,
//               costCentreId: currentLine.costCentre ? null : line.costCentreId,
//               costCentreName:
//                 currentLine.costCentre?.name || line.costCentreName || "",
//               costCentreNameFromDropdown:
//                 currentLine.costCentre?.name || line.costCentreNameFromDropdown,
//               narration: currentLine.narration,
//               customerId: currentLine.customer?.id || null,
//               customerName: currentLine.customer?.name || null,
//               customerMobile: currentLine.customer?.mobile || null,
//             };
//           }
//           if (
//             line.isContraEntry &&
//             Math.abs(
//               parseFloat(line.amount) -
//                 parseFloat(prev[editingLineIndex].amount),
//             ) < 0.01
//           ) {
//             return {
//               ...line,
//               amount: parseFloat(currentLine.amount).toFixed(2),
//               entryType: currentLine.entryType === "DEBIT" ? "CREDIT" : "DEBIT",
//             };
//           }
//           return line;
//         });
//         return updated.map((l, i) => ({ ...l, slNo: i + 1 }));
//       });

//       setEditingLineIndex(null);
//       setCurrentLine({
//         entryType: voucherData.voucherType === "RECEIPT" ? "CREDIT" : "DEBIT",
//         account: null,
//         amount: "",
//         costCentre: null,
//         narration: "",
//         customer: null,
//       });
//       setAccountCodeInput("");
//       setAccountInputValue("");
//       setCustomerInputValue("");
//       setPartyDetails({
//         code: "",
//         mobile: "",
//         name: "",
//         address: "",
//         balance: 0,
//         balanceType: "DEBIT",
//       });
//       setShowCustomerField(false);
//       setErrors({});
//       showSnackbar("Entry updated", "success");
//       return;
//     }

//     const newLine = {
//       slNo: voucherLines.length + 1,
//       accountId: currentLine.account.account_id,
//       accountCode: currentLine.account.account_code || "",
//       accountName: currentLine.account.account_name,
//       entryType: currentLine.entryType,
//       amount: parseFloat(currentLine.amount).toFixed(2),
//       costCentre: currentLine.costCentre,
//       costCentreId: null,
//       costCentreName: currentLine.costCentre?.name || "",
//       costCentreNameFromDropdown: currentLine.costCentre?.name || null,
//       narration: currentLine.narration,
//       isContraEntry: false,
//       customerId: currentLine.customer?.id || null,
//       customerName: currentLine.customer?.name || null,
//       customerMobile: currentLine.customer?.mobile || null,
//     };

//     setVoucherLines((prev) => {
//       const newLines = [...prev, newLine];
//       if (voucherData.contraBank) {
//         const contraEntry = {
//           slNo: newLines.length + 1,
//           accountId: voucherData.contraBank.account_id,
//           accountCode: voucherData.contraBank.account_code || "",
//           accountName: voucherData.contraBank.account_name,
//           entryType: currentLine.entryType === "DEBIT" ? "CREDIT" : "DEBIT",
//           amount: parseFloat(currentLine.amount).toFixed(2),
//           costCentre: currentLine.costCentre,
//           costCentreId: null,
//           costCentreName: currentLine.costCentre?.name || "",
//           costCentreNameFromDropdown: currentLine.costCentre?.name || null,
//           narration: `Contra entry for ${
//             currentLine.account.isParty
//               ? currentLine.customer?.name || "Party"
//               : currentLine.account.account_name
//           }`,
//           isContraEntry: true,
//           customerId: null,
//           customerName: null,
//           customerMobile: null,
//         };
//         newLines.push(contraEntry);
//       }
//       return newLines.map((line, i) => ({ ...line, slNo: i + 1 }));
//     });

//     const nextEntryType =
//       voucherData.voucherType === "PAYMENT"
//         ? "DEBIT"
//         : voucherData.voucherType === "RECEIPT"
//         ? "CREDIT"
//         : currentLine.entryType === "DEBIT"
//         ? "CREDIT"
//         : "DEBIT";

//     setCurrentLine({
//       entryType: nextEntryType,
//       account: currentLine.account,
//       amount: "",
//       costCentre: currentLine.costCentre,
//       narration: "",
//       customer: null,
//     });
//     setCustomerInputValue("");
//     setPartyDetails({
//       code: "",
//       mobile: "",
//       name: "",
//       address: "",
//       balance: 0,
//       balanceType: "DEBIT",
//     });
//     if (currentLine.account?.isParty) setShowCustomerField(true);
//     setErrors({});
//     showSnackbar("Entry added successfully", "success");
//   };

//   const deleteLineFromGrid = (index) => {
//     const lineToDelete = voucherLines[index];
//     setVoucherLines((prev) => {
//       let filtered = prev.filter((_, i) => i !== index);
//       if (!lineToDelete.isContraEntry && voucherData.contraBank) {
//         const contraIndex = filtered.findIndex(
//           (line, idx) =>
//             line.isContraEntry &&
//             idx >= index &&
//             parseFloat(line.amount) === parseFloat(lineToDelete.amount),
//         );
//         if (contraIndex !== -1) {
//           filtered = filtered.filter((_, i) => i !== contraIndex);
//         }
//       }
//       return filtered.map((line, i) => ({ ...line, slNo: i + 1 }));
//     });
//     showSnackbar("Entry deleted", "info");
//   };

//   const validateVoucher = () => {
//     if (voucherLines.length < 2) return "Need minimum 2 entries";
//     if (!isBalanced) return "Debit ≠ Credit";
//     return null;
//   };

//   const createSavePayload = () => ({
//     store_id,
//     voucher_date: voucherData.voucherDate,
//     user_id,
//     voucher_type: voucherData.voucherType,
//     voucher_no: voucherData.voucherNo,
//     narration: voucherData.narration,
//     contra_bank_id: voucherData.contraBank?.account_id || null,
//     total_debit: parseFloat(totalDebit.toFixed(2)),
//     total_credit: parseFloat(totalCredit.toFixed(2)),
//     status: "POSTED",
//     created_at: new Date().toISOString(),
//     entries: voucherLines.map((line) => ({
//       account_id: line.accountId,
//       pay_type: line.entryType === "DEBIT" ? "D" : "C",
//       amount: parseFloat(line.amount),
//       costcentreid: line?.costCentreId,
//       entry_narration: line.narration,
//       is_contra_entry: line.isContraEntry,
//       party_account: line.customerId,
//     })),
//     fy_id: defaultFYId,
//     finance_year: defaultFY,
//   });

//   const handleSave = async () => {
//     const validationError = validateVoucher();
//     if (validationError) {
//       showSnackbar(validationError, "error");
//       return;
//     }

//     const payload = createSavePayload();

//     try {
//       let response;

//       if (isEditMode && originalVoucherNo) {
//         response = await axios.put(
//           `${process.env.REACT_APP_API_BASE_URL}/api/accounts/ledger`,
//           {
//             ...payload,
//             voucherNumber: originalVoucherNo,
//             updated_at: new Date().toISOString(),
//           },
//         );
//         if (response.data.success)
//           showSnackbar("✓ Voucher updated successfully!", "success");
//       } else {
//         response = await axios.post(
//           `${process.env.REACT_APP_API_BASE_URL}/api/accounts/ledger`,
//           payload,
//         );
//         if (response.data.success)
//           showSnackbar("✓ Voucher saved successfully!", "success");
//       }

//       if (response.data.success) {
//         setTimeout(async () => {
//           const newVoucherNo = await fetchVoucherNumber(
//             voucherData.voucherType,
//           );
//           setVoucherData((prev) => ({ ...prev, voucherNo: newVoucherNo }));
//           setVoucherLines([]);
//           setCurrentLine((prev) => ({
//             entryType:
//               voucherData.voucherType === "RECEIPT" ? "CREDIT" : "DEBIT",
//             account: prev.account,
//             amount: "",
//             costCentre: null,
//             narration: "",
//             customer: null,
//           }));
//           setCustomerInputValue("");
//           setPartyDetails({
//             code: "",
//             mobile: "",
//             name: "",
//             address: "",
//             balance: 0,
//             balanceType: "DEBIT",
//           });
//           setErrors({});
//           setIsHeaderLocked(true);
//           setIsEditMode(false);
//           setOriginalVoucherNo(null);
//           setEditingLineIndex(null);
//         }, 1500);
//       } else {
//         showSnackbar(
//           response.data.message || "Something went wrong...",
//           "error",
//         );
//       }
//     } catch (error) {
//       console.error("Error saving voucher:", error);
//       showSnackbar(
//         error.response?.data?.message || "Error saving voucher",
//         "error",
//       );
//     }
//   };

//   // ==================== DELETE VOUCHER HANDLER ====================
//   const handleDeleteVoucher = () => {
//     setDeleteDialog({
//       open: true,
//       mode: isEditMode ? "api" : "local",
//       deleting: false,
//     });
//   };

//   const handleDeleteConfirm = async () => {
//     if (deleteDialog.mode === "api") {
//       try {
//         setDeleteDialog((prev) => ({ ...prev, deleting: true }));

//         const response = await axios.post(
//           `${process.env.REACT_APP_API_BASE_URL}/api/accounts/delete-ledger`,
//           { voucherNumber: originalVoucherNo },
//         );

//         if (response.data.success) {
//           showSnackbar(
//             `✓ Voucher ${originalVoucherNo} deleted successfully`,
//             "success",
//           );
//           setDeleteDialog({ open: false, mode: null, deleting: false });
//           resetToNew();
//         } else {
//           showSnackbar(
//             response.data.message || "Failed to delete voucher",
//             "error",
//           );
//           setDeleteDialog((prev) => ({ ...prev, deleting: false }));
//         }
//       } catch (error) {
//         console.error("Error deleting voucher:", error);
//         showSnackbar(
//           error.response?.data?.message || "Error deleting voucher",
//           "error",
//         );
//         setDeleteDialog((prev) => ({ ...prev, deleting: false }));
//       }
//     } else {
//       setDeleteDialog({ open: false, mode: null, deleting: false });
//       resetToNew();
//       showSnackbar("Voucher cleared", "info");
//     }
//   };

//   const resetToNew = () => {
//     clearHeaderSession();
//     const defaultType = "PAYMENT";
//     setVoucherData({
//       voucherDate: getTodayDate(),
//       voucherType: defaultType,
//       voucherNo: "",
//       narration: "",
//       contraBank: null,
//     });
//     setVoucherNoInput("");
//     setVoucherLines([]);
//     setCurrentLine({
//       entryType: "DEBIT",
//       account: null,
//       amount: "",
//       costCentre: null,
//       narration: "",
//       customer: null,
//     });
//     setAccountCodeInput("");
//     setAccountInputValue("");
//     setCustomerInputValue("");
//     setShowCustomerField(false);
//     setErrors({});
//     setIsHeaderLocked(false);
//     setIsEditMode(false);
//     setOriginalVoucherNo(null);
//     setEditingLineIndex(null);
//     setContraBalance(0);
//     setContraBalanceType("DEBIT");
//     setAccountBalance(0);
//     setAccountBalanceType("DEBIT");
//     setPartyDetails({
//       code: "",
//       mobile: "",
//       name: "",
//       address: "",
//       balance: 0,
//       balanceType: "DEBIT",
//     });
//     fetchVoucherNumber(defaultType);
//   };

//   const handleNew = () => {
//     resetToNew();
//     showSnackbar("New voucher created", "info");
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   const handleCreateAccount = (accountName) => {
//     navigate("/accounts", {
//       state: { createAccountName: accountName, returnPath: "/accounts-entry" },
//     });
//   };

//   const handleToggleHeaderLock = () => {
//     setIsHeaderLocked((prev) => {
//       const nowLocked = !prev;
//       if (!nowLocked) {
//         setVoucherNoInput(voucherData.voucherNo);
//         showSnackbar(
//           "Voucher No unlocked — type and press Enter to set or load",
//           "info",
//         );
//       }
//       return nowLocked;
//     });
//   };

//   const handleVoucherNoClick = async (e) => {
//     if (e.key !== "Enter") return;
//     const typed = voucherNoInput.trim();
//     if (!typed) {
//       showSnackbar("Please enter a voucher number", "warning");
//       return;
//     }
//     await fetchVoucherData(typed);
//     setVoucherData((prev) => {
//       if (!isEditMode) return { ...prev, voucherNo: typed };
//       return prev;
//     });
//   };

//   const balDisplay = getBalanceDisplay(
//     partyDetails.balance,
//     partyDetails.balanceType,
//   );
//   const accBalDisplay = getBalanceDisplay(accountBalance, accountBalanceType);
//   const contraBalDisplay = getBalanceDisplay(contraBalance, contraBalanceType);

//   // ==================== KEYBOARD SHORTCUTS ====================
//   useEffect(() => {
//     const handleKeyPress = (e) => {
//       if (e.key === "F3") {
//         e.preventDefault();
//         handleDeleteVoucher();
//       } else if (e.key === "F4") {
//         e.preventDefault();
//         handleNew();
//       } else if (e.key === "F5") {
//         e.preventDefault();
//         handleSave();
//       }
//     };
//     window.addEventListener("keydown", handleKeyPress);
//     return () => window.removeEventListener("keydown", handleKeyPress);
//   }, [voucherLines, voucherData, isEditMode, originalVoucherNo]);

//   const handleAccountCodeEnter = (e) => {
//     if (e.key !== "Enter") return;
//     const code = accountCodeInput.trim().toUpperCase();
//     const matchedAccount = accountOptionsWithParty.find(
//       (acc) => acc.account_code && acc.account_code.toUpperCase() === code,
//     );
//     if (matchedAccount) {
//       handleAccountSelect(matchedAccount);
//       setErrors((prev) => ({ ...prev, account: null }));
//     } else {
//       setErrors((prev) => ({ ...prev, account: "Invalid code" }));
//     }
//   };

//   const filteredCostCenters = useMemo(() => {
//     if (!currentLine.account) return [];
//     return costCenters.filter(
//       (centre) => centre.acc_no === currentLine.account.account_id,
//     );
//   }, [costCenters, currentLine.account]);

//   console.log(filteredCostCenters);

//   const currentYear = new Date().getFullYear();
//   const fiscalYear = `FY ${currentYear - 1}-${String(currentYear).slice(-2)}`;

//   const handleBack = () => {
//     if (isFromLedger) {
//       navigate("/accounts-ledger", {
//         state: {
//           fromAccountsEntry: true,
//           highlightVoucher: location.state?.voucher_no,
//           reopenDialog: location.state?.reopenDialog || false,
//           dialogPartyId: location.state?.dialogPartyId || null,
//           dialogAccountId: location.state?.dialogAccountId || null,
//         },
//       });
//     } else {
//       navigate(-1);
//     }
//   };

//   // ==================== RENDER ====================
//   return (
//     <Box
//       sx={{
//         p: 1.5,
//         borderRadius: 5,
//         maxWidth: 1400,
//         margin: "0 auto",
//         mt: 1,
//         bgcolor: "#f1f5f9",
//       }}
//     >
//       {/* ── GRADIENT HEADER BAR ── */}
//       <Box
//         sx={{
//           background: "linear-gradient(135deg, #1e3a8a 0%, #0891b2 100%)",
//           px: 3,
//           py: 2,
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           borderRadius: "16px 16px 0 0",
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//           <Box
//             onClick={handleBack}
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               cursor: "pointer",
//               borderRadius: 2,
//               bgcolor: "#ffffff2f",
//               p: 0.5,
//             }}
//           >
//             <ArrowBackRoundedIcon sx={{ fill: "#FFF" }} />
//           </Box>
//           <Box
//             onClick={() => navigate("/travel/dashboard")}
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               cursor: "pointer",
//               borderRadius: 2,
//               bgcolor: "#ffffff2f",
//               p: 0.5,
//             }}
//           >
//             <HouseIcon sx={{ fill: "#FFF" }} />
//           </Box>
//           <Typography
//             variant="h5"
//             sx={{ color: "#fff", fontWeight: 700, letterSpacing: 0.5 }}
//           >
//             Voucher Entry
//           </Typography>{" "}
//         </Box>
//         <Typography
//           variant="body2"
//           sx={{ color: "rgba(255,255,255,0.85)", fontWeight: 500 }}
//         >
//           Accounting Period:{" "}
//           <span style={{ fontWeight: 600 }}>
//             {" "}
//             {defaultFY}-{defaultFY + 1}
//           </span>
//         </Typography>
//       </Box>

//       {/* ── MAIN CARD ── */}
//       <Paper
//         elevation={0}
//         sx={{
//           borderRadius: "0 0 16px 16px",
//           border: "1px solid #e2e8f0",
//           borderTop: "none",
//           overflow: "hidden",
//         }}
//       >
//         {/* ════════ ROW 1 — Date | Type | Contra | Voucher No | icons ════════ */}
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 1.5,
//             px: 2.5,
//             py: 1.75,
//             bgcolor: "#fff",
//             borderBottom: "1px solid #e2e8f0",
//           }}
//         >
//           {/* Date */}
//           <TextField
//             label="Date"
//             type="date"
//             value={voucherData.voucherDate}
//             onChange={(e) => handleVoucherChange("voucherDate", e.target.value)}
//             InputLabelProps={{ shrink: true }}
//             size="small"
//             sx={{ width: 155 }}
//           />

//           {/* Type */}
//           <FormControl size="small" sx={{ width: 155 }}>
//             <InputLabel>Type</InputLabel>
//             <Select
//               value={voucherData.voucherType}
//               label="Type"
//               onChange={(e) =>
//                 handleVoucherChange("voucherType", e.target.value)
//               }
//             >
//               <MenuItem value="PAYMENT">PAYMENT</MenuItem>
//               <MenuItem value="RECEIPT">RECEIPT</MenuItem>
//               <MenuItem value="JOURNAL">JOURNAL</MenuItem>
//               <MenuItem value="CONTRA">CONTRA</MenuItem>
//             </Select>
//           </FormControl>

//           {/* Contra Bank + balance badge */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//             <Autocomplete
//               options={[
//                 { account_id: null, account_name: "None" },
//                 ...bankAccounts,
//               ]}
//               getOptionLabel={(option) => option.account_name || ""}
//               value={
//                 voucherData.contraBank || {
//                   account_id: null,
//                   account_name: "None",
//                 }
//               }
//               onChange={(e, newValue) =>
//                 handleVoucherChange(
//                   "contraBank",
//                   newValue?.account_id ? newValue : null,
//                 )
//               }
//               renderInput={(params) => (
//                 <TextField {...params} label="Contra" size="small" />
//               )}
//               isOptionEqualToValue={(option, value) =>
//                 option.account_id === value?.account_id
//               }
//               sx={{ width: 250 }}
//             />
//           </Box>

//           {/* Voucher No */}
//           <TextField
//             label="Voucher No"
//             value={isHeaderLocked ? voucherData.voucherNo : voucherNoInput}
//             onChange={(e) =>
//               !isHeaderLocked && setVoucherNoInput(e.target.value)
//             }
//             onKeyDown={handleVoucherNoClick}
//             InputProps={{
//               readOnly: isHeaderLocked,
//               endAdornment: loadingVoucher ? (
//                 <InputAdornment position="end">
//                   <CircularProgress size={20} />
//                 </InputAdornment>
//               ) : null,
//             }}
//             disabled={isHeaderLocked}
//             size="small"
//             placeholder="Type voucher no and press Enter..."
//             sx={{
//               width: 220,
//               bgcolor: isHeaderLocked ? "#f8fafc" : "#fff",
//               "& .MuiInputBase-root": {
//                 bgcolor: isHeaderLocked ? "#f1f5f9" : "#fff",
//               },
//             }}
//           />
//           {voucherData.contraBank && (
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 0.75,
//                 px: 1.5,
//                 py: 0.5,
//                 bgcolor: "#f0f9ff",
//                 border: "1px solid #bae6fd",
//                 borderRadius: 2,
//                 whiteSpace: "nowrap",
//               }}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: "#64748b",
//                   fontWeight: 500,
//                   fontSize: "0.78rem",
//                 }}
//               >
//                 Bal:
//               </Typography>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontWeight: 700,
//                   fontSize: "0.82rem",
//                   color: contraBalDisplay.color,
//                 }}
//               >
//                 {contraBalDisplay.text}
//               </Typography>
//             </Box>
//           )}
//           <Box sx={{ flex: 1 }} />

//           {/* Eye icon */}
//           <IconButton
//             size="small"
//             sx={{ border: "1px solid #e2e8f0", borderRadius: 1.5, p: 0.75 }}
//           >
//             <VisibilityIcon fontSize="small" sx={{ color: "#64748b" }} />
//           </IconButton>

//           {/* Pencil / Lock Icon */}
//           <Tooltip
//             title={
//               isHeaderLocked
//                 ? "Click to edit Voucher No"
//                 : "Click to lock Voucher No"
//             }
//           >
//             <IconButton
//               size="small"
//               onClick={handleToggleHeaderLock}
//               sx={{
//                 border: `1.5px solid ${isHeaderLocked ? "#e2e8f0" : "#0891b2"}`,
//                 borderRadius: 1.5,
//                 p: 0.75,
//                 bgcolor: isHeaderLocked ? "transparent" : "#e0f2fe",
//                 transition: "all 0.2s ease",
//                 "&:hover": {
//                   bgcolor: isHeaderLocked ? "#f1f5f9" : "#bae6fd",
//                 },
//               }}
//             >
//               {isHeaderLocked ? (
//                 <EditIcon fontSize="small" sx={{ color: "#64748b" }} />
//               ) : (
//                 <LockOpenIcon fontSize="small" sx={{ color: "#0891b2" }} />
//               )}
//             </IconButton>
//           </Tooltip>

//           {/* Edit Mode Indicator */}
//           {isEditMode && (
//             <Chip
//               icon={<EditIcon sx={{ fontSize: "0.75rem !important" }} />}
//               label={`Editing: ${originalVoucherNo}`}
//               size="small"
//               sx={{
//                 height: 22,
//                 fontSize: "0.68rem",
//                 bgcolor: "#fef3c7",
//                 color: "#92400e",
//                 border: "1px solid #fbbf24",
//                 "& .MuiChip-icon": { color: "#b45309" },
//               }}
//             />
//           )}

//           {/* Locked indicator badge */}
//           {isHeaderLocked && !isEditMode && (
//             <Chip
//               icon={<LockIcon sx={{ fontSize: "0.75rem !important" }} />}
//               label="Locked"
//               size="small"
//               sx={{
//                 height: 22,
//                 fontSize: "0.68rem",
//                 bgcolor: "#f1f5f9",
//                 color: "#64748b",
//                 border: "1px solid #e2e8f0",
//                 "& .MuiChip-icon": { color: "#94a3b8" },
//               }}
//             />
//           )}
//         </Box>

//         {/* ════════ ROW 2 — Account Code | Account Name | party/balance fields ════════ */}
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 1.5,
//             px: 2.5,
//             py: 1.75,
//             bgcolor: "#fff",
//             borderBottom: "1px solid #e2e8f0",
//           }}
//         >
//           {/* Account Code */}
//           <TextField
//             label="Account Code"
//             size="small"
//             value={accountCodeInput}
//             onChange={(e) => setAccountCodeInput(e.target.value)}
//             onKeyDown={handleAccountCodeEnter}
//             placeholder="6001"
//             error={!!errors.account}
//             sx={{ width: 130, flexShrink: 0 }}
//           />

//           {/* Account Name */}
//           <Autocomplete
//             ListboxProps={{
//               sx: {
//                 maxHeight: 300,
//                 overflowY: "auto",
//                 "&::-webkit-scrollbar": { width: 0 },
//                 scrollbarWidth: "none",
//               },
//             }}
//             options={accountOptionsWithParty}
//             getOptionLabel={(option) =>
//               `${option.account_code ? option.account_code + " - " : ""}${
//                 option.account_name
//               }`
//             }
//             value={currentLine.account}
//             inputValue={accountInputValue}
//             onInputChange={(e, newInputValue) =>
//               setAccountInputValue(newInputValue)
//             }
//             onChange={(e, newValue) => handleAccountSelect(newValue)}
//             filterOptions={(options, params) => {
//               const filtered = options.filter((option) => {
//                 const searchStr = params.inputValue.toLowerCase();
//                 const accountName = option.account_name.toLowerCase();
//                 const accountCode = (option.account_code || "").toLowerCase();
//                 return (
//                   accountName.includes(searchStr) ||
//                   accountCode.includes(searchStr)
//                 );
//               });
//               if (params.inputValue !== "" && filtered.length === 0) {
//                 return [
//                   { isCreateOption: true, account_name: params.inputValue },
//                 ];
//               }
//               return filtered;
//             }}
//             renderOption={(props, option) => {
//               if (option.isCreateOption) {
//                 return (
//                   <ListItem
//                     {...props}
//                     key="create-new"
//                     onClick={() => handleCreateAccount(option.account_name)}
//                   >
//                     <ListItemIcon>
//                       <AddCircleIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={`Create "${option.account_name}"`}
//                       primaryTypographyProps={{
//                         color: "primary",
//                         fontWeight: 500,
//                       }}
//                     />
//                   </ListItem>
//                 );
//               }
//               return (
//                 <li {...props}>
//                   {option.isParty && (
//                     <Chip
//                       label="PARTY"
//                       size="small"
//                       color="primary"
//                       sx={{ mr: 1, height: 20 }}
//                     />
//                   )}
//                   {`${option.account_code ? option.account_code + " - " : ""}${
//                     option.account_name
//                   }`}
//                 </li>
//               );
//             }}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Account Name"
//                 error={!!errors.account}
//                 helperText={errors.account}
//                 size="small"
//               />
//             )}
//             loading={loading}
//             freeSolo={false}
//             selectOnFocus
//             clearOnBlur
//             handleHomeEndKeys
//             sx={{ width: 230, flexShrink: 0 }}
//           />

//           {/* NON-PARTY: inline balance */}
//           {currentLine.account && !showCustomerField && (
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 px: 2,
//                 py: 0.6,
//                 bgcolor: "#f0f9ff",
//                 border: "1px solid #bae6fd",
//                 borderRadius: 2,
//                 flexShrink: 0,
//               }}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: "#64748b",
//                   fontWeight: 500,
//                   fontSize: "0.78rem",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 Balance:
//               </Typography>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontWeight: 700,
//                   fontSize: "0.82rem",
//                   color: accBalDisplay.color,
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 {accBalDisplay.text}
//               </Typography>
//             </Box>
//           )}

//           {/* PARTY FIELDS */}
//           {showCustomerField && (
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: 1.5,
//                 flex: 1,
//                 alignItems: "center",
//                 minWidth: 0,
//               }}
//             >
//               {/* Party Code */}
//               <TextField
//                 label="Party Code"
//                 size="small"
//                 value={partyDetails.code}
//                 onChange={(e) =>
//                   setPartyDetails((prev) => ({ ...prev, code: e.target.value }))
//                 }
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter") {
//                     e.preventDefault();
//                     fetchCustomerByPartyCode(partyDetails.code);
//                   }
//                 }}
//                 placeholder="P001"
//                 InputProps={{
//                   endAdornment: loadingCustomers ? (
//                     <InputAdornment position="end">
//                       <CircularProgress color="inherit" size={16} />
//                     </InputAdornment>
//                   ) : null,
//                 }}
//                 sx={{ width: 120, flexShrink: 0 }}
//               />

//               {/* Mobile */}
//               <Autocomplete
//                 options={customerOptions}
//                 getOptionLabel={(option) => option.mobile || ""}
//                 value={currentLine.customer}
//                 inputValue={partyDetails.mobile}
//                 loading={loadingCustomers}
//                 onInputChange={(e, value) => {
//                   setPartyDetails((prev) => ({ ...prev, mobile: value }));
//                   if (value.trim().length >= 3)
//                     fetchCustomersByMobile(value.trim());
//                   else setCustomerOptions([]);
//                 }}
//                 onChange={(e, newValue) => {
//                   if (newValue) {
//                     handleLineChange("customer", newValue);
//                     setErrors((prev) => ({ ...prev, customer: null }));
//                     setCustomerInputValue(newValue.name || "");
//                     setPartyDetails({
//                       code: newValue.party_code || "",
//                       mobile: newValue.mobile || "",
//                       name: newValue.name || "",
//                       address: newValue.address || "",
//                       balance: newValue.balance || 0,
//                       balanceType: newValue.balanceType || "DEBIT",
//                     });
//                     fetchBalance(newValue.id, "customer", "party");
//                   }
//                 }}
//                 renderOption={(props, option) => (
//                   <li {...props}>
//                     <Box sx={{ display: "flex", gap: 1 }}>
//                       <PersonIcon fontSize="small" color="action" />
//                       <Box>
//                         <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                           {option.mobile}
//                           {option.whatsapp &&
//                             option.whatsapp !== option.mobile && (
//                               <Chip
//                                 label="WA"
//                                 size="small"
//                                 color="success"
//                                 sx={{ ml: 1, height: 16, fontSize: "0.65rem" }}
//                               />
//                             )}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {option.name}
//                           {option.company_name && ` • ${option.company_name}`}
//                         </Typography>
//                         {option.matched_related_mobiles?.map((rel, i) => (
//                           <Typography
//                             key={i}
//                             variant="caption"
//                             color="text.secondary"
//                             display="block"
//                           >
//                             {rel.relation}: {rel.number}
//                           </Typography>
//                         ))}
//                         {option.address && (
//                           <Typography
//                             variant="caption"
//                             color="text.secondary"
//                             display="block"
//                           >
//                             📍 {option.address}
//                           </Typography>
//                         )}
//                       </Box>
//                     </Box>
//                   </li>
//                 )}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Mobile"
//                     size="small"
//                     placeholder="Type 3+ digits..."
//                     InputProps={{
//                       ...params.InputProps,
//                       endAdornment: (
//                         <>
//                           {loadingCustomers ? (
//                             <CircularProgress color="inherit" size={20} />
//                           ) : null}
//                           {params.InputProps.endAdornment}
//                         </>
//                       ),
//                     }}
//                   />
//                 )}
//                 noOptionsText={
//                   partyDetails.mobile.length < 3
//                     ? "Type at least 3 digits"
//                     : loadingCustomers
//                     ? "Searching..."
//                     : "No customers found"
//                 }
//                 filterOptions={(x) => x}
//                 freeSolo
//                 sx={{ flex: 1, minWidth: 160 }}
//               />

//               {/* Search Party */}
//               <Autocomplete
//                 options={customerOptions}
//                 getOptionLabel={(option) => `${option.name} - ${option.mobile}`}
//                 value={currentLine.customer}
//                 inputValue={customerInputValue}
//                 loading={loadingCustomers}
//                 onInputChange={(e, value) => {
//                   setCustomerInputValue(value);
//                   searchCustomers(value);
//                 }}
//                 onChange={(e, newValue) => {
//                   handleLineChange("customer", newValue);
//                   setErrors((prev) => ({ ...prev, customer: null }));
//                   if (newValue) {
//                     setPartyDetails({
//                       code: newValue.party_code || "",
//                       mobile: newValue.mobile || "",
//                       name: newValue.name || "",
//                       address: newValue.address || "",
//                       balance: 0,
//                       balanceType: "DEBIT",
//                     });
//                     fetchBalance(newValue.id, "customer", "party");
//                   }
//                 }}
//                 renderOption={(props, option) => (
//                   <li {...props}>
//                     <Box sx={{ display: "flex", gap: 1 }}>
//                       <PersonIcon fontSize="small" color="action" />
//                       <Box>
//                         <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                           {option.name}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {option.mobile}
//                           {option.company_name && ` • ${option.company_name}`}
//                         </Typography>
//                         {option.address && (
//                           <Typography
//                             variant="caption"
//                             color="text.secondary"
//                             display="block"
//                           >
//                             📍 {option.address}
//                           </Typography>
//                         )}
//                       </Box>
//                     </Box>
//                   </li>
//                 )}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Search Party"
//                     size="small"
//                     error={!!errors.customer}
//                     helperText={errors.customer}
//                     placeholder="Type name or mobile..."
//                     InputProps={{
//                       ...params.InputProps,
//                       endAdornment: (
//                         <>
//                           {loadingCustomers ? (
//                             <CircularProgress color="inherit" size={20} />
//                           ) : null}
//                           {params.InputProps.endAdornment}
//                           <InputAdornment position="end">
//                             <SearchIcon
//                               fontSize="small"
//                               sx={{ color: "#94a3b8" }}
//                             />
//                           </InputAdornment>
//                         </>
//                       ),
//                     }}
//                   />
//                 )}
//                 noOptionsText={
//                   customerInputValue.length < 2
//                     ? "Type at least 3 characters"
//                     : loadingCustomers
//                     ? "Searching..."
//                     : "No customers found"
//                 }
//                 filterOptions={(x) => x}
//                 sx={{ flex: 1.4, minWidth: 200 }}
//               />
//             </Box>
//           )}
//         </Box>

//         {/* ════════ INFO BAR — only for PARTY ════════ */}
//         <Collapse
//           in={showCustomerField && !!currentLine.account}
//           timeout="auto"
//           unmountOnExit
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               px: 2.5,
//               py: 0.9,
//               bgcolor: "#f8fafc",
//               borderBottom: "1px solid #e2e8f0",
//               gap: 0,
//               flexWrap: "wrap",
//             }}
//           >
//             <Box
//               sx={{ display: "flex", alignItems: "center", gap: 1, pr: 2.5 }}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{ color: "#64748b", fontWeight: 500, fontSize: "0.8rem" }}
//               >
//                 Account Balance:
//               </Typography>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontWeight: 700,
//                   fontSize: "0.85rem",
//                   color: accBalDisplay.color,
//                 }}
//               >
//                 {accBalDisplay.text}
//               </Typography>
//             </Box>

//             {currentLine.customer && (
//               <>
//                 {partyDetails.address && (
//                   <>
//                     <Divider
//                       orientation="vertical"
//                       flexItem
//                       sx={{ mx: 2, borderColor: "#e2e8f0" }}
//                     />
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 0.5,
//                         pr: 2.5,
//                       }}
//                     >
//                       <LocationOnIcon
//                         sx={{ fontSize: "0.9rem", color: "#94a3b8" }}
//                       />
//                       <Typography
//                         variant="body2"
//                         sx={{ fontSize: "0.8rem", color: "#475569" }}
//                       >
//                         {partyDetails.address}
//                       </Typography>
//                     </Box>
//                   </>
//                 )}

//                 {partyDetails.mobile && (
//                   <>
//                     <Divider
//                       orientation="vertical"
//                       flexItem
//                       sx={{ mx: 2, borderColor: "#e2e8f0" }}
//                     />
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 0.5,
//                         pr: 2.5,
//                       }}
//                     >
//                       <PhoneIcon
//                         sx={{ fontSize: "0.9rem", color: "#94a3b8" }}
//                       />
//                       <Typography
//                         variant="body2"
//                         sx={{ fontSize: "0.8rem", color: "#475569" }}
//                       >
//                         {partyDetails.mobile}
//                       </Typography>
//                     </Box>
//                   </>
//                 )}

//                 <Divider
//                   orientation="vertical"
//                   flexItem
//                   sx={{ mx: 2, borderColor: "#e2e8f0" }}
//                 />
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: "#64748b",
//                       fontWeight: 500,
//                       fontSize: "0.8rem",
//                     }}
//                   >
//                     Party Balance:
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontWeight: 700,
//                       fontSize: "0.85rem",
//                       color: balDisplay.color,
//                     }}
//                   >
//                     {balDisplay.text}
//                   </Typography>
//                 </Box>
//               </>
//             )}
//           </Box>
//         </Collapse>

//         {/* ════════ ROW 3 — Amount | Dr/Cr | Cost Centre | Narration | + Add ════════ */}
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "flex-start",
//             gap: 1.5,
//             px: 2.5,
//             py: 1.75,
//             bgcolor: "#fff",
//           }}
//         >
//           {/* Amount */}
//           <TextField
//             label="Amount"
//             type="number"
//             value={currentLine.amount}
//             onChange={(e) => handleLineChange("amount", e.target.value)}
//             error={!!errors.amount}
//             helperText={errors.amount}
//             size="small"
//             inputProps={{ step: "0.01", min: "0" }}
//             sx={{ width: 150, flexShrink: 0 }}
//           />

//           {/* Dr/Cr */}
//           <FormControl size="small" sx={{ width: 120, flexShrink: 0 }}>
//             <InputLabel>Db/Cr</InputLabel>
//             <Select
//               value={currentLine.entryType}
//               label="Db/Cr"
//               onChange={(e) => handleLineChange("entryType", e.target.value)}
//             >
//               <MenuItem value="DEBIT">Db</MenuItem>
//               <MenuItem value="CREDIT">Cr</MenuItem>
//             </Select>
//           </FormControl>

//           {/* Cost Centre */}
//           <Autocomplete
//             options={filteredCostCenters}
//             disabled={!currentLine.account}
//             getOptionLabel={(option) => option.name || ""}
//             value={currentLine.costCentre}
//             onChange={(e, newValue) => handleLineChange("costCentre", newValue)}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Cost Centre"
//                 size="small"
//                 placeholder="Select Centre"
//               />
//             )}
//             isOptionEqualToValue={(option, value) => option?.id === value?.id}
//             sx={{ width: 190, flexShrink: 0 }}
//           />

//           {/* Narration */}
//           <TextField
//             label="Narration"
//             value={currentLine.narration}
//             onChange={(e) => handleLineChange("narration", e.target.value)}
//             size="small"
//             placeholder="Enter narration..."
//             sx={{ flex: 1, minWidth: 0 }}
//           />

//           {/* Add / Update Line Button */}
//           <Button
//             variant="contained"
//             onClick={addLineToGrid}
//             startIcon={editingLineIndex !== null ? <EditIcon /> : <AddIcon />}
//             sx={{
//               height: 40,
//               px: 3,
//               flexShrink: 0,
//               background:
//                 editingLineIndex !== null
//                   ? "linear-gradient(135deg, #b45309 0%, #d97706 100%)"
//                   : "linear-gradient(135deg, #1e3a8a 0%, #0891b2 100%)",
//               "&:hover": {
//                 background:
//                   editingLineIndex !== null
//                     ? "linear-gradient(135deg, #92400e 0%, #b45309 100%)"
//                     : "linear-gradient(135deg, #1e40af 0%, #0e7490 100%)",
//               },
//               borderRadius: 2,
//               fontWeight: 600,
//               textTransform: "none",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {editingLineIndex !== null ? "Update Line" : "Add"}
//           </Button>
//         </Box>

//         <Divider sx={{ mx: 2.5, borderColor: "#e2e8f0" }} />

//         {/* ════════ ENTRIES TABLE ════════ */}
//         <TableContainer sx={{ maxHeight: 320, mt: 1.5 }}>
//           <Table size="small" stickyHeader>
//             <TableHead>
//               <TableRow>
//                 {[
//                   "Sl",
//                   "Code",
//                   "Account",
//                   "Customer",
//                   "Debit",
//                   "Credit",
//                   "Centre",
//                   "Narration",
//                   "Del",
//                 ].map((col) => (
//                   <TableCell
//                     key={col}
//                     align={["Debit", "Credit"].includes(col) ? "right" : "left"}
//                     sx={{
//                       bgcolor: "#1e3a8a",
//                       color: "white",
//                       py: 0.75,
//                       fontSize: "0.78rem",
//                       fontWeight: 600,
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {col}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {voucherLines.length === 0 ? (
//                 <TableRow>
//                   <TableCell
//                     colSpan={9}
//                     align="center"
//                     sx={{ py: 4, color: "#94a3b8", fontSize: "0.85rem" }}
//                   >
//                     No entries yet. Add your first entry above ↑
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 voucherLines.map((line, index) => (
//                   <TableRow
//                     key={index}
//                     onClick={() => handleRowClick(line, index)}
//                     sx={{
//                       cursor: line.isContraEntry ? "default" : "pointer",
//                       "&:hover": {
//                         bgcolor: line.isContraEntry ? "#f0fdf4" : "#e0f2fe",
//                       },
//                       bgcolor:
//                         editingLineIndex === index
//                           ? "#bae6fd !important"
//                           : line.isContraEntry
//                           ? "#f0fdf4"
//                           : line.entryType === "DEBIT"
//                           ? "#fffbeb"
//                           : "#eff6ff",
//                       outline:
//                         editingLineIndex === index
//                           ? "2px solid #0891b2"
//                           : "none",
//                     }}
//                   >
//                     <TableCell sx={{ py: 0.5, fontSize: "0.8rem" }}>
//                       {line.slNo}
//                       {line.isContraEntry && (
//                         <Chip
//                           label="C"
//                           size="small"
//                           color="success"
//                           sx={{ ml: 0.5, height: 16, fontSize: "0.65rem" }}
//                         />
//                       )}
//                     </TableCell>
//                     <TableCell sx={{ py: 0.5, fontSize: "0.8rem" }}>
//                       {line.accountCode || "-"}
//                     </TableCell>
//                     <TableCell sx={{ py: 0.5, fontSize: "0.8rem" }}>
//                       {line.accountName}
//                     </TableCell>
//                     <TableCell sx={{ py: 0.5, fontSize: "0.75rem" }}>
//                       {line.customerName ? (
//                         <Box>
//                           <Typography
//                             variant="caption"
//                             sx={{ fontWeight: 500 }}
//                           >
//                             {line.customerName}
//                           </Typography>
//                           <Typography
//                             variant="caption"
//                             color="text.secondary"
//                             display="block"
//                           >
//                             {line.customerMobile}
//                           </Typography>
//                         </Box>
//                       ) : (
//                         "-"
//                       )}
//                     </TableCell>
//                     <TableCell
//                       align="right"
//                       sx={{ py: 0.5, fontSize: "0.8rem", fontWeight: 500 }}
//                     >
//                       {line.entryType === "DEBIT"
//                         ? formatCurrency(line.amount)
//                         : "-"}
//                     </TableCell>
//                     <TableCell
//                       align="right"
//                       sx={{ py: 0.5, fontSize: "0.8rem", fontWeight: 500 }}
//                     >
//                       {line.entryType === "CREDIT"
//                         ? formatCurrency(line.amount)
//                         : "-"}
//                     </TableCell>
//                     <TableCell sx={{ py: 0.5, fontSize: "0.75rem" }}>
//                       {line.costCentreNameFromDropdown ||
//                         line.costCentreId ||
//                         "-"}
//                     </TableCell>
//                     <TableCell sx={{ py: 0.5, fontSize: "0.75rem" }}>
//                       {line.narration || "-"}
//                     </TableCell>
//                     <TableCell sx={{ py: 0.5 }}>
//                       <IconButton
//                         size="small"
//                         color="error"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           deleteLineFromGrid(index);
//                         }}
//                         disabled={line.isContraEntry}
//                       >
//                         <DeleteIcon sx={{ fontSize: "1rem" }} />
//                       </IconButton>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* ════════ FOOTER — Totals + Action Buttons ════════ */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             px: 2,
//             py: 1.25,
//             bgcolor: "#f8fafc",
//             borderTop: "1px solid #e2e8f0",
//             flexWrap: "wrap",
//             gap: 1,
//           }}
//         >
//           {/* Totals */}
//           <Box sx={{ display: "flex", gap: 3 }}>
//             <Typography
//               variant="body2"
//               sx={{ color: "#64748b", fontSize: "0.8rem" }}
//             >
//               Total Debit:{" "}
//               <Box component="span" sx={{ fontWeight: 700, color: "#dc2626" }}>
//                 ₹{formatCurrency(totalDebit)}
//               </Box>
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{ color: "#64748b", fontSize: "0.8rem" }}
//             >
//               Total Credit:{" "}
//               <Box component="span" sx={{ fontWeight: 700, color: "#16a34a" }}>
//                 ₹{formatCurrency(totalCredit)}
//               </Box>
//             </Typography>
//             {voucherLines.length > 0 && !isBalanced && (
//               <Typography
//                 variant="body2"
//                 sx={{ color: "#dc2626", fontWeight: 600, fontSize: "0.8rem" }}
//               >
//                 Diff: ₹{formatCurrency(Math.abs(difference))}
//               </Typography>
//             )}
//             {voucherLines.length >= 2 && isBalanced && (
//               <Chip
//                 label="✓ Balanced"
//                 size="small"
//                 color="success"
//                 sx={{ height: 20, fontSize: "0.7rem" }}
//               />
//             )}
//           </Box>

//           {/* Action Buttons */}
//           <Box sx={{ display: "flex", gap: 1 }}>
//             <Button
//               variant="outlined"
//               size="small"
//               startIcon={<NewIcon />}
//               onClick={handleNew}
//               sx={{ textTransform: "none" }}
//             >
//               New
//             </Button>
//             <Button
//               variant="outlined"
//               size="small"
//               color="error"
//               startIcon={<DeleteForeverIcon />}
//               onClick={handleDeleteVoucher}
//               sx={{ textTransform: "none" }}
//             >
//               Delete
//             </Button>
//             <Button
//               variant="outlined"
//               size="small"
//               startIcon={<PrintIcon />}
//               onClick={handlePrint}
//               sx={{ textTransform: "none" }}
//             >
//               Print
//             </Button>
//             <Button
//               variant="contained"
//               size="small"
//               startIcon={<SaveIcon />}
//               onClick={handleSave}
//               disabled={!isBalanced || voucherLines.length < 2}
//               sx={{
//                 textTransform: "none",
//                 background: isEditMode
//                   ? "linear-gradient(135deg, #b45309 0%, #d97706 100%)"
//                   : "linear-gradient(135deg, #1e3a8a 0%, #0891b2 100%)",
//                 "&:hover": {
//                   background: isEditMode
//                     ? "linear-gradient(135deg, #92400e 0%, #b45309 100%)"
//                     : "linear-gradient(135deg, #1e40af 0%, #0e7490 100%)",
//                 },
//                 "&.Mui-disabled": { opacity: 0.5 },
//               }}
//             >
//               {isEditMode ? "Update" : "Save"}
//             </Button>
//           </Box>
//         </Box>
//       </Paper>

//       {/* ════════ DELETE CONFIRMATION DIALOG ════════ */}
//       <Dialog
//         open={deleteDialog.open}
//         onClose={() =>
//           !deleteDialog.deleting &&
//           setDeleteDialog({ open: false, mode: null, deleting: false })
//         }
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 1.5,
//             pb: 1,
//             color: deleteDialog.mode === "api" ? "#dc2626" : "#b45309",
//           }}
//         >
//           <WarningIcon
//             sx={{ color: deleteDialog.mode === "api" ? "#dc2626" : "#d97706" }}
//           />
//           {deleteDialog.mode === "api" ? "Delete Voucher" : "Discard Changes"}
//         </DialogTitle>

//         <DialogContent sx={{ pt: 0 }}>
//           {deleteDialog.mode === "api" ? (
//             <DialogContentText>
//               Are you sure you want to permanently delete voucher{" "}
//               <Box component="span" sx={{ fontWeight: 700, color: "#1e3a8a" }}>
//                 {originalVoucherNo}
//               </Box>
//               ? This action{" "}
//               <Box component="span" sx={{ fontWeight: 700, color: "#dc2626" }}>
//                 cannot be undone
//               </Box>{" "}
//               and all ledger entries will be removed.
//             </DialogContentText>
//           ) : (
//             <DialogContentText>
//               You have unsaved entries in this voucher. Are you sure you want to
//               discard all changes? All data entered will be{" "}
//               <Box component="span" sx={{ fontWeight: 700, color: "#b45309" }}>
//                 lost
//               </Box>
//               .
//             </DialogContentText>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
//           <Button
//             onClick={() =>
//               setDeleteDialog({ open: false, mode: null, deleting: false })
//             }
//             disabled={deleteDialog.deleting}
//             variant="outlined"
//             size="small"
//             sx={{ textTransform: "none" }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleDeleteConfirm}
//             disabled={deleteDialog.deleting}
//             variant="contained"
//             size="small"
//             color="error"
//             startIcon={
//               deleteDialog.deleting ? (
//                 <CircularProgress size={14} color="inherit" />
//               ) : (
//                 <DeleteForeverIcon />
//               )
//             }
//             sx={{ textTransform: "none", minWidth: 110 }}
//           >
//             {deleteDialog.deleting
//               ? "Deleting..."
//               : deleteDialog.mode === "api"
//               ? "Yes, Delete"
//               : "Yes, Discard"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* ── CONFIRMATION DIALOG (type / contra change) ── */}
//       <Dialog
//         open={confirmDialog.open}
//         onClose={() => handleConfirmDialogClose(false)}
//       >
//         <DialogTitle>Confirm Change</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             You have existing entries. Changing the{" "}
//             {confirmDialog.field === "voucherType"
//               ? "voucher type"
//               : "contra bank"}{" "}
//             will clear all entries. Do you want to continue?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => handleConfirmDialogClose(false)}>
//             Cancel
//           </Button>
//           <Button
//             onClick={() => handleConfirmDialogClose(true)}
//             color="error"
//             variant="contained"
//           >
//             Clear & Continue
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* ── SNACKBAR ── */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           sx={{ width: "100%" }}
//           variant="filled"
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AccountEntry;

import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAccountsNav } from "../../utils/moduleNav";
import { PawnAccountsSkin } from "./pawnAccountsTheme";
import { usePawnLedgerScope } from "./pawnLedgerScope";
import {
  Box,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Autocomplete,
  Grid,
  Divider,
  Alert,
  IconButton,
  Snackbar,
  Chip,
  ListItem,
  ListItemText,
  ListItemIcon,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Collapse,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  Print as PrintIcon,
  NoteAdd as NewIcon,
  DeleteForever as DeleteForeverIcon,
  AddCircleOutline as AddCircleIcon,
  Person as PersonIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Search as SearchIcon,
  LocationOn as LocationOnIcon,
  Phone as PhoneIcon,
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
  ArrowBack as ArrowBackIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";
import { AutoTaskAuthContext } from "../../Context/AutoTaskContext";
import axios from "axios";
import debounce from "lodash/debounce";
import { Preferences } from "@capacitor/preferences";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import HouseIcon from "@mui/icons-material/House";

// ==================== CONSTANTS ====================
const SESSION_KEY = "accountEntry_headerState";

// ==================== UTILITY FUNCTIONS ====================
const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);
};

const getBalanceDisplay = (balance, balanceType = "DEBIT") => {
  const abs = formatCurrency(Math.abs(balance));

  if (balance === 0) return { text: `₹0.00`, color: "inherit" };

  // If balance is positive, show the balance type from API
  // If balance is negative, show opposite type
  const displayType =
    balance >= 0 ? balanceType : balanceType === "DEBIT" ? "CREDIT" : "DEBIT";
  const displayText = displayType === "CREDIT" ? "Cr" : "Db";
  const displayColor = displayType === "CREDIT" ? "#16a34a" : "#dc2626";

  return { text: `₹${abs} ${displayText}`, color: displayColor };
};

const getTodayDate = () => {
  return new Date().toISOString().split("T")[0];
};

// ==================== SESSION STORAGE HELPERS ====================
const readHeaderFromSession = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const writeHeaderToSession = (
  voucherData,
  accountCodeInput,
  accountInputValue,
  selectedAccount = null,
) => {
  try {
    sessionStorage.setItem(
      SESSION_KEY,
      JSON.stringify({
        voucherDate: voucherData.voucherDate,
        voucherType: voucherData.voucherType,
        voucherNo: voucherData.voucherNo,
        narration: voucherData.narration,
        contraBank: voucherData.contraBank,
        accountCodeInput,
        accountInputValue,
        selectedAccount,
      }),
    );
  } catch {
    // sessionStorage write failure is non-fatal
  }
};

const clearHeaderSession = () => {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // ignore
  }
};

// ==================== MAIN COMPONENT ====================
const AccountEntry = () => {
  // const defaultFY = Preferences.get({ key: defaultFY });

  const { userInfo, defaultFY, defaultFYId } =
    useContext(AutoTaskAuthContext) || {};

  const user_id = userInfo?.id;
  const store_id = userInfo?.store_id || 0;

  const location = useLocation();
  const navigate = useNavigate();
  // Host module (Daily Tick / Travel / Pawn): decides the home target and keeps
  // the sibling accounts screens inside the same route tree.
  const { inPawn, go: goAccounts, goHome } = useAccountsNav();
  // A pawn voucher number exists in up to two books (official / unofficial), so
  // loading one has to say which — see usePawnLedgerScope.
  const { pawnMode } = usePawnLedgerScope();

  const isFromLedger = location.state?.fromLedger === true;

  const savedSession = readHeaderFromSession();

  const [voucherData, setVoucherData] = useState({
    // voucherDate: savedSession?.voucherDate ?? getTodayDate(),
    voucherDate: getTodayDate(),
    voucherType: savedSession?.voucherType ?? "PAYMENT",
    voucherNo: savedSession?.voucherNo ?? "",
    narration: savedSession?.narration ?? "",
    contraBank: savedSession?.contraBank ?? null,
  });

  const [currentLine, setCurrentLine] = useState({
    entryType: savedSession?.voucherType === "RECEIPT" ? "CREDIT" : "DEBIT",
    account: savedSession?.selectedAccount ?? null,
    amount: "",
    costCentre: null,
    narration: "",
    customer: null,
  });

  const [partyDetails, setPartyDetails] = useState({
    code: "",
    mobile: "",
    name: "",
    address: "",
    balance: 0,
    balanceType: "DEBIT",
  });

  const [successModal, setSuccessModal] = useState({
    open: false,
    voucherNo: "",
    voucherType: "",
    totalDebit: 0,
    totalCredit: 0,
    entryCount: 0,
  });

  const [voucherLines, setVoucherLines] = useState([]);
  console.log(voucherLines);
  const [errors, setErrors] = useState({});
  const [accountCodeInput, setAccountCodeInput] = useState(
    savedSession?.accountCodeInput ?? "",
  );
  const [accountInputValue, setAccountInputValue] = useState(
    savedSession?.accountInputValue ?? "",
  );
  const [voucherNoInput, setVoucherNoInput] = useState(
    savedSession?.voucherNo ?? "",
  );

  const [isHeaderLocked, setIsHeaderLocked] = useState(!!savedSession);

  // ── Edit mode states ──
  const [isEditMode, setIsEditMode] = useState(false);
  const [loadingVoucher, setLoadingVoucher] = useState(false);
  const [originalVoucherNo, setOriginalVoucherNo] = useState(null);
  const [editingLineIndex, setEditingLineIndex] = useState(null);

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    field: null,
    newValue: null,
  });

  // ── Delete confirmation dialog ──
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    mode: null,
    deleting: false,
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [accounts, setAccounts] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [costCenters, setCostCenters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accountBalance, setAccountBalance] = useState(0);
  const [accountBalanceType, setAccountBalanceType] = useState("DEBIT");

  // ── Balance for the selected contra bank ──
  const [contraBalance, setContraBalance] = useState(0);
  const [contraBalanceType, setContraBalanceType] = useState("DEBIT");

  const [customerOptions, setCustomerOptions] = useState([]);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [showCustomerField, setShowCustomerField] = useState(
    !!savedSession?.selectedAccount?.isParty,
  );
  const [customerInputValue, setCustomerInputValue] = useState("");

  // ==================== SNACKBAR HELPER ====================
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // ==================== CLEAR SESSION ON NAVIGATION ====================
  useEffect(() => {
    return () => {
      clearHeaderSession();
    };
  }, []);

  // ==================== HANDLE NEWLY CREATED ACCOUNT ====================
  useEffect(() => {
    if (location.state?.newAccount) {
      const newAccount = location.state.newAccount;
      setCurrentLine((prev) => ({ ...prev, account: newAccount }));
      setAccountCodeInput(newAccount.account_code || "");
      setAccountInputValue(newAccount.account_name || "");
      fetchAccounts();
      window.history.replaceState({}, document.title);
      showSnackbar("✓ Account created and selected!");
    }
  }, [location.state]);

  // ==================== HANDLE INCOMING VOUCHER_NO FROM NAVIGATION ====================
  useEffect(() => {
    if (location.state?.voucher_no) {
      const voucherNo = location.state.voucher_no;
      setVoucherNoInput(voucherNo);
      fetchVoucherData(voucherNo);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // ==================== API CALLS ====================
  useEffect(() => {
    if (store_id !== null && store_id !== undefined) {
      fetchAccounts();
      fetchCostCenters();
      // if (!savedSession && !location.state?.voucher_no) {
      //   fetchVoucherNumber("PAYMENT");
      // }
    }
  }, [store_id]);

  useEffect(() => {
    if (accounts.length > 0 && currentLine.account) {
      fetchBalance(currentLine.account.account_id, "account", "account");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts]);

  const fetchAccounts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/accounts/accounts/${store_id}/accounts-only`,
      );
      if (response.data.success) {
        const allAccounts = response.data.data.map((acc) =>
          acc.account_name?.toLowerCase() === "party"
            ? { ...acc, isParty: true }
            : acc,
        );
        setAccounts(allAccounts);
        const banks = allAccounts.filter((acc) => acc.is_bank_account === true);
        setBankAccounts(banks);
      }
    } catch (error) {
      console.error("Error fetching accounts:", error);
      showSnackbar("Error loading accounts", "error");
    } finally {
      setLoading(false);
    }
  };

  // ✅ fetchCostCenters parses acc_nos array
  const fetchCostCenters = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/accounts/cost-centers/${store_id}`,
      );
      if (response.data.success) {
        const parsedCenters = response.data.data.map((cc) => ({
          ...cc,
          acc_nos: (() => {
            if (Array.isArray(cc.acc_nos)) return cc.acc_nos;
            if (typeof cc.acc_nos === "string") {
              try {
                return JSON.parse(cc.acc_nos);
              } catch {
                return [];
              }
            }
            return [];
          })(),
        }));
        setCostCenters(parsedCenters);
      }
    } catch (error) {
      console.error("Error fetching cost centers:", error);
    }
  };

  const fetchVoucherNumber = async (voucherType) => {
    try {
      setLoadingVoucher(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/accounts/generate-voucher/${voucherType}/${store_id}/${defaultFY}`,
      );
      if (response.data.success) {
        const newNo = response.data.data.voucher_number;
        setVoucherData((prev) => ({ ...prev, voucherNo: newNo }));
        setVoucherNoInput(newNo);
        return newNo;
      }
    } catch (error) {
      console.error("Error generating voucher number:", error);
      showSnackbar("Error generating voucher number", "error");
    } finally {
      setLoadingVoucher(false);
    }
    return "";
  };

  const fetchCustomerByPartyCode = async (code) => {
    if (!code.trim()) return;
    try {
      setLoadingCustomers(true);
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/travel/customers/by-party-code/${store_id}/${code.trim()}`,
      );
      if (response.data.success) {
        const matched = response.data.data;
        handleLineChange("customer", matched);
        setCustomerInputValue(matched.name || "");
        setPartyDetails({
          code: matched.party_code || "",
          mobile: matched.mobile || "",
          name: matched.name || "",
          address: matched.address || "",
          balance: matched.balance || 0,
          balanceType: matched.balanceType || "DEBIT",
        });
        fetchBalance(matched.id, "customer");
        setErrors((prev) => ({ ...prev, customer: null }));
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setPartyDetails({
          code: "",
          mobile: "",
          name: "",
          address: "",
          balance: 0,
          balanceType: "DEBIT",
        });
        setCustomerInputValue("");
        handleLineChange("customer", null);
        showSnackbar("No customer found with this party code", "warning");
      } else {
        showSnackbar("Error fetching customer", "error");
      }
    } finally {
      setLoadingCustomers(false);
    }
  };

  const fetchCustomersByMobile = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm || searchTerm.trim().length < 3) {
        setCustomerOptions([]);
        return;
      }
      try {
        setLoadingCustomers(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/travel/customers/search/${store_id}`,
          { params: { q: searchTerm.trim(), limit: 50, numericOnly: true } },
        );
        if (response.data.success) {
          setCustomerOptions(response.data.data || []);
        } else {
          setCustomerOptions([]);
        }
      } catch (error) {
        console.error("Error searching customers by mobile:", error);
        setCustomerOptions([]);
      } finally {
        setLoadingCustomers(false);
      }
    }, 300),
    [store_id],
  );

  const fetchBalance = useCallback(
    async (id, type, target = "party") => {
      if (!id) return;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/accounts/balance/${id}/${defaultFYId}`,
          { params: { type } },
        );
        if (response.data.success) {
          const balance = response.data.data.closing_balance;
          const balanceType =
            response.data.data.closing_balance_type || "DEBIT";

          if (target === "account") {
            setAccountBalance(balance);
            setAccountBalanceType(balanceType);
          } else if (target === "contra") {
            setContraBalance(balance);
            setContraBalanceType(balanceType);
          } else {
            setPartyDetails((prev) => ({ ...prev, balance, balanceType }));
          }
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    },
    [defaultFYId],
  );

  useEffect(() => {
    return () => {
      fetchCustomersByMobile.cancel();
    };
  }, [fetchCustomersByMobile]);

  const searchCustomers = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm || searchTerm.trim().length < 2) {
        setCustomerOptions([]);
        return;
      }
      if (store_id === null || store_id === undefined) return;
      try {
        setLoadingCustomers(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/travel/customers/search/${store_id}`,
          { params: { q: searchTerm.trim(), limit: 50 } },
        );
        if (response.data.success) {
          setCustomerOptions(response.data.data || []);
        } else {
          setCustomerOptions([]);
        }
      } catch (error) {
        console.error("Error searching customers:", error);
        setCustomerOptions([]);
        showSnackbar("Error searching customers", "error");
      } finally {
        setLoadingCustomers(false);
      }
    }, 300),
    [store_id],
  );

  useEffect(() => {
    return () => {
      searchCustomers.cancel();
    };
  }, [searchCustomers]);

  // ==================== FETCH VOUCHER FOR EDITING ====================
  const fetchVoucherData = async (voucherNumber) => {
    if (!voucherNumber.trim()) {
      showSnackbar("Please enter a voucher number", "warning");
      return;
    }

    try {
      setLoadingVoucher(true);

      let currentAccounts = accounts;
      let currentCostCenters = costCenters;
      let currentBankAccounts = bankAccounts;

      if (accounts.length === 0) {
        const accRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/accounts/accounts/${store_id}/accounts-only`,
        );
        if (accRes.data.success) {
          currentAccounts = accRes.data.data.map((acc) =>
            acc.account_name?.toLowerCase() === "party"
              ? { ...acc, isParty: true }
              : acc,
          );
          setAccounts(currentAccounts);
          currentBankAccounts = currentAccounts.filter(
            (acc) => acc.is_bank_account === true,
          );
          setBankAccounts(currentBankAccounts);
        }
      }

      if (costCenters.length === 0) {
        const ccRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/accounts/cost-centers/${store_id}`,
        );
        if (ccRes.data.success) {
          const parsedCenters = ccRes.data.data.map((cc) => ({
            ...cc,
            acc_nos: (() => {
              if (Array.isArray(cc.acc_nos)) return cc.acc_nos;
              if (typeof cc.acc_nos === "string") {
                try {
                  return JSON.parse(cc.acc_nos);
                } catch {
                  return [];
                }
              }
              return [];
            })(),
          }));
          currentCostCenters = parsedCenters;
          setCostCenters(currentCostCenters);
        }
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/accounts/ledger-by-voucherno`,
        {
          params: {
            voucherNumber: voucherNumber,
            ...(pawnMode ? { pawn_mode: pawnMode } : {}),
          },
        },
      );

      if (response.data.success && response.data.data.length > 0) {
        const entries = response.data.data;
        const firstEntry = entries[0];

        const voucherDate = firstEntry.voucherdate
          ? firstEntry.voucherdate.split("T")[0]
          : getTodayDate();

        const contraEntry = entries.find(
          (entry) =>
            entry.is_contra_entry === true || entry.is_contra_entry === 1,
        );
        const contraBankAccount = contraEntry
          ? currentBankAccounts.find(
              (acc) => acc.account_id === parseInt(contraEntry.account),
            ) || null
          : null;

        setVoucherData({
          voucherDate,
          voucherType: firstEntry.voucher_type || "JOURNAL",
          voucherNo: firstEntry.vouchernumber,
          narration: firstEntry.narration || "",
          contraBank: contraBankAccount,
        });
        setVoucherNoInput(firstEntry.vouchernumber);

        if (contraBankAccount?.account_id) {
          fetchBalance(contraBankAccount.account_id, "account", "contra");
        } else {
          setContraBalance(0);
          setContraBalanceType("DEBIT");
        }

        const transformedLines = entries.map((entry, index) => {
          const account = currentAccounts.find(
            (acc) => acc.account_id === parseInt(entry.account),
          );
          const costCentreIdFromAPI = entry.costcentreid || null;
          const costCentre = costCentreIdFromAPI
            ? currentCostCenters.find((cc) => cc.id === costCentreIdFromAPI)
            : null;
          const debitAmt = parseFloat(entry.debit_amount || 0);
          const creditAmt = parseFloat(entry.credit_amount || 0);
          const isDebit = debitAmt > 0;
          const entryType = isDebit ? "DEBIT" : "CREDIT";
          const amount = isDebit ? debitAmt : creditAmt;
          const isContra =
            entry.is_contra_entry === true || entry.is_contra_entry === 1;

          return {
            slNo: index + 1,
            accountId: parseInt(entry.account),
            accountCode: account?.account_code || "",
            accountName: account?.account_name || `Account #${entry.account}`,
            entryType,
            amount: amount.toFixed(2),
            costCentre: costCentre || null,
            costCentreId: costCentreIdFromAPI,
            costCentreName: costCentre?.name || "",
            costCentreNameFromDropdown: null,
            narration: entry.vnarration || entry.narration || "",
            isContraEntry: isContra,
            customerId: entry.party_account || null,
            customerName: null,
            customerMobile: null,
          };
        });

        setVoucherLines(transformedLines);

        const nonContraLines = transformedLines.filter((l) => !l.isContraEntry);
        const partyLine = nonContraLines.find((l) => l.customerId);
        const nonPartyLine = nonContraLines.find((l) => !l.customerId);
        const formLine = partyLine || nonPartyLine || nonContraLines[0];
        if (formLine) {
          const formAccount = currentAccounts.find(
            (acc) => acc.account_id === formLine.accountId,
          );
          if (formAccount) {
            setCurrentLine((prev) => ({
              ...prev,
              account: formAccount,
              entryType: formLine.entryType,
              customer: null,
            }));
            setAccountCodeInput(formAccount.account_code || "");
            setAccountInputValue(
              `${
                formAccount.account_code ? formAccount.account_code + " - " : ""
              }${formAccount.account_name}`,
            );
            if (formAccount.isParty) {
              setShowCustomerField(true);
              fetchBalance(formAccount.account_id, "account", "account");
            } else {
              setShowCustomerField(false);
              fetchBalance(formAccount.account_id, "account", "account");
            }
          }
        }

        setIsEditMode(true);
        setOriginalVoucherNo(voucherNumber.trim());
        setIsHeaderLocked(true);

        showSnackbar(
          `✓ Voucher ${voucherNumber} loaded for editing`,
          "success",
        );

        for (const line of nonContraLines) {
          if (line.customerId) {
            try {
              const custResponse = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/travel/customers/${line.customerId}`,
              );
              if (custResponse.data.success) {
                const customer = custResponse.data.data;
                setVoucherLines((prev) =>
                  prev.map((l) =>
                    l.customerId === line.customerId
                      ? {
                          ...l,
                          customerName: customer.name,
                          customerMobile: customer.mobile,
                        }
                      : l,
                  ),
                );

                if (formLine && line.accountId === formLine.accountId) {
                  const customerObj = {
                    id: customer.id,
                    name: customer.name,
                    mobile: customer.mobile,
                    party_code: customer.party_code || "",
                    address: customer.address || "",
                    balance: customer.balance || 0,
                  };
                  setCurrentLine((prev) => ({
                    ...prev,
                    customer: customerObj,
                  }));
                  setCustomerInputValue(customer.name || "");
                  setPartyDetails({
                    code: customer.party_code || "",
                    mobile: customer.mobile || "",
                    name: customer.name || "",
                    address: customer.address || "",
                    balance: customer.balance || 0,
                    balanceType: customer.balanceType || "DEBIT",
                  });
                  setShowCustomerField(true);
                  fetchBalance(customer.id, "customer", "party");
                }
              }
            } catch (error) {
              console.error("Error fetching customer:", error);
            }
          }
        }
      } else {
        showSnackbar("No voucher found with this number", "warning");
      }
    } catch (error) {
      console.error("Error fetching voucher:", error);
      if (error.response?.status === 404) {
        showSnackbar("Voucher not found", "error");
      } else {
        showSnackbar("Error loading voucher", "error");
      }
    } finally {
      setLoadingVoucher(false);
    }
  };

  // ==================== COMPUTED VALUES ====================
  const totalDebit = voucherLines
    .filter((line) => line.entryType === "DEBIT")
    .reduce((sum, line) => sum + parseFloat(line.amount || 0), 0);

  const totalCredit = voucherLines
    .filter((line) => line.entryType === "CREDIT")
    .reduce((sum, line) => sum + parseFloat(line.amount || 0), 0);

  const difference = totalDebit - totalCredit;
  const isBalanced = Math.abs(difference) < 0.01;

  const accountOptionsWithParty = accounts;

  // ==================== HANDLERS ====================
  useEffect(() => {
    writeHeaderToSession(
      voucherData,
      accountCodeInput,
      accountInputValue,
      currentLine.account,
    );
  }, [voucherData, accountCodeInput, accountInputValue, currentLine.account]);

  const handleVoucherChange = (field, value) => {
    if (
      voucherLines.length > 0 &&
      (field === "voucherType" || field === "contraBank")
    ) {
      setConfirmDialog({ open: true, field, newValue: value });
      return;
    }
    applyVoucherChange(field, value);
  };

  const applyVoucherChange = (field, value) => {
    setVoucherData((prev) => {
      const updates = { ...prev, [field]: value };
      if (field === "voucherType") {
        updates.voucherNo = "";
        setVoucherNoInput("");
        if (value === "PAYMENT") {
          setCurrentLine((prev) => ({ ...prev, entryType: "DEBIT" }));
        } else if (value === "RECEIPT") {
          setCurrentLine((prev) => ({ ...prev, entryType: "CREDIT" }));
        }
        // fetchVoucherNumber(value);
      }
      if (field === "contraBank") {
        if (value?.account_id) {
          fetchBalance(value.account_id, "account", "contra");
        } else {
          setContraBalance(0);
          setContraBalanceType("DEBIT");
        }
      }
      return updates;
    });
  };

  const handleConfirmDialogClose = (confirmed) => {
    if (confirmed && confirmDialog.field) {
      setVoucherLines([]);
      applyVoucherChange(confirmDialog.field, confirmDialog.newValue);
      showSnackbar("Entries cleared. Voucher settings updated.", "info");
    }
    setConfirmDialog({ open: false, field: null, newValue: null });
  };

  const handleLineChange = (field, value) => {
    setCurrentLine((prev) => ({ ...prev, [field]: value }));
  };

  const handleAccountSelect = (newValue) => {
    if (!newValue) {
      setAccountBalance(0);
      setAccountBalanceType("DEBIT");
    }
    handleLineChange("account", newValue);
    setAccountCodeInput(newValue?.account_code || "");
    setCurrentLine((prev) => ({ ...prev, costCentre: null }));

    if (newValue?.isParty) {
      setShowCustomerField(true);
      setCustomerInputValue("");
      setCustomerOptions([]);
      setPartyDetails({
        code: "",
        mobile: "",
        name: "",
        address: "",
        balance: 0,
        balanceType: "DEBIT",
      });
      handleLineChange("customer", null);
      setAccountBalance(0);
      setAccountBalanceType("DEBIT");
      if (newValue?.account_id)
        fetchBalance(newValue.account_id, "account", "account");
    } else {
      setShowCustomerField(false);
      setCustomerInputValue("");
      setCustomerOptions([]);
      setPartyDetails({
        code: "",
        mobile: "",
        name: "",
        address: "",
        balance: 0,
        balanceType: "DEBIT",
      });
      handleLineChange("customer", null);
      setAccountBalance(0);
      setAccountBalanceType("DEBIT");
      if (newValue?.account_id)
        fetchBalance(newValue.account_id, "account", "account");
    }
  };

  const validateCurrentLine = () => {
    const newErrors = {};
    if (!currentLine.account) newErrors.account = "Select account";
    if (currentLine.account?.isParty && !currentLine.customer)
      newErrors.customer = "Select customer";
    if (!currentLine.amount || parseFloat(currentLine.amount) <= 0)
      newErrors.amount = "Amount > 0";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRowClick = (line, index) => {
    if (line.isContraEntry) return;
    const account = accounts.find((acc) => acc.account_id === line.accountId);
    if (!account) return;

    setCurrentLine({
      entryType: line.entryType,
      account,
      amount: parseFloat(line.amount).toString(),
      costCentre: line.costCentre || null,
      narration: line.narration || "",
      customer: line.customerId
        ? {
            id: line.customerId,
            name: line.customerName || "",
            mobile: line.customerMobile || "",
            party_code: partyDetails.code || "",
            address: partyDetails.address || "",
          }
        : null,
    });

    setAccountCodeInput(account.account_code || "");
    setAccountInputValue(
      `${account.account_code ? account.account_code + " - " : ""}${
        account.account_name
      }`,
    );

    if (account.isParty && line.customerId) {
      setShowCustomerField(true);
      setCustomerInputValue(line.customerName || "");
      setPartyDetails((prev) => ({
        ...prev,
        name: line.customerName || "",
        mobile: line.customerMobile || "",
        code: prev.code || "",
        address: prev.address || "",
      }));
      fetchBalance(line.customerId, "customer", "party");
      fetchBalance(account.account_id, "account", "account");
    } else {
      setShowCustomerField(false);
      setCustomerInputValue("");
      fetchBalance(account.account_id, "account", "account");
    }

    setEditingLineIndex(index);
    setErrors({});
  };

  // 🛠️ CORRECTED addLineToGrid – ensures costcentreId is sent
  const addLineToGrid = () => {
    if (!validateCurrentLine()) {
      showSnackbar("Please fix the errors", "error");
      return;
    }

    if (editingLineIndex !== null) {
      // Update existing line
      setVoucherLines((prev) => {
        const updated = prev.map((line, i) => {
          if (i === editingLineIndex) {
            return {
              ...line,
              accountId: currentLine.account.account_id,
              accountCode: currentLine.account.account_code || "",
              accountName: currentLine.account.account_name,
              entryType: currentLine.entryType,
              amount: parseFloat(currentLine.amount).toFixed(2),
              costCentreId: currentLine.costCentre?.id ?? null,
              costCentre: currentLine.costCentre,
              costCentreName: currentLine.costCentre?.name || "",
              costCentreNameFromDropdown: currentLine.costCentre?.name || null,
              narration: currentLine.narration,
              customerId: currentLine.customer?.id || null,
              customerName: currentLine.customer?.name || null,
              customerMobile: currentLine.customer?.mobile || null,
            };
          }
          // Update contra entry amount if it matches old amount (keep in sync)
          if (
            line.isContraEntry &&
            Math.abs(
              parseFloat(line.amount) -
                parseFloat(prev[editingLineIndex].amount),
            ) < 0.01
          ) {
            return {
              ...line,
              amount: parseFloat(currentLine.amount).toFixed(2),
              entryType: currentLine.entryType === "DEBIT" ? "CREDIT" : "DEBIT",
            };
          }
          return line;
        });
        return updated.map((l, i) => ({ ...l, slNo: i + 1 }));
      });

      setEditingLineIndex(null);
      setCurrentLine({
        entryType: voucherData.voucherType === "RECEIPT" ? "CREDIT" : "DEBIT",
        account: null,
        amount: "",
        costCentre: null,
        narration: "",
        customer: null,
      });
      setAccountCodeInput("");
      setAccountInputValue("");
      setCustomerInputValue("");
      setPartyDetails({
        code: "",
        mobile: "",
        name: "",
        address: "",
        balance: 0,
        balanceType: "DEBIT",
      });
      setShowCustomerField(false);
      setErrors({});
      showSnackbar("Entry updated", "success");
      return;
    }

    // Create new line
    const newLine = {
      slNo: voucherLines.length + 1,
      accountId: currentLine.account.account_id,
      accountCode: currentLine.account.account_code || "",
      accountName: currentLine.account.account_name,
      entryType: currentLine.entryType,
      amount: parseFloat(currentLine.amount).toFixed(2),
      costCentreId: currentLine.costCentre?.id ?? null,
      costCentre: currentLine.costCentre,
      costCentreName: currentLine.costCentre?.name || "",
      costCentreNameFromDropdown: currentLine.costCentre?.name || null,
      narration: currentLine.narration,
      isContraEntry: false,
      customerId: currentLine.customer?.id || null,
      customerName: currentLine.customer?.name || null,
      customerMobile: currentLine.customer?.mobile || null,
    };

    setVoucherLines((prev) => {
      const newLines = [...prev, newLine];
      if (voucherData.contraBank) {
        const contraEntry = {
          slNo: newLines.length + 1,
          accountId: voucherData.contraBank.account_id,
          accountCode: voucherData.contraBank.account_code || "",
          accountName: voucherData.contraBank.account_name,
          entryType: currentLine.entryType === "DEBIT" ? "CREDIT" : "DEBIT",
          amount: parseFloat(currentLine.amount).toFixed(2),
          costCentreId: currentLine.costCentre?.id ?? null,
          costCentre: currentLine.costCentre,
          costCentreName: currentLine.costCentre?.name || "",
          costCentreNameFromDropdown: currentLine.costCentre?.name || null,
          narration: `Contra entry for ${
            currentLine.account.isParty
              ? currentLine.customer?.name || "Party"
              : currentLine.account.account_name
          }`,
          isContraEntry: true,
          customerId: null,
          customerName: null,
          customerMobile: null,
        };
        newLines.push(contraEntry);
      }
      return newLines.map((line, i) => ({ ...line, slNo: i + 1 }));
    });

    const nextEntryType =
      voucherData.voucherType === "PAYMENT"
        ? "DEBIT"
        : voucherData.voucherType === "RECEIPT"
          ? "CREDIT"
          : currentLine.entryType === "DEBIT"
            ? "CREDIT"
            : "DEBIT";

    setCurrentLine({
      entryType: nextEntryType,
      account: currentLine.account,
      amount: "",
      costCentre: currentLine.costCentre,
      narration: "",
      customer: null,
    });
    setCustomerInputValue("");
    setPartyDetails({
      code: "",
      mobile: "",
      name: "",
      address: "",
      balance: 0,
      balanceType: "DEBIT",
    });
    if (currentLine.account?.isParty) setShowCustomerField(true);
    setErrors({});
    showSnackbar("Entry added successfully", "success");
  };

  const deleteLineFromGrid = (index) => {
    const lineToDelete = voucherLines[index];
    setVoucherLines((prev) => {
      let filtered = prev.filter((_, i) => i !== index);
      if (!lineToDelete.isContraEntry && voucherData.contraBank) {
        const contraIndex = filtered.findIndex(
          (line, idx) =>
            line.isContraEntry &&
            idx >= index &&
            parseFloat(line.amount) === parseFloat(lineToDelete.amount),
        );
        if (contraIndex !== -1) {
          filtered = filtered.filter((_, i) => i !== contraIndex);
        }
      }
      return filtered.map((line, i) => ({ ...line, slNo: i + 1 }));
    });
    showSnackbar("Entry deleted", "info");
  };

  const validateVoucher = () => {
    if (voucherLines.length < 2) return "Need minimum 2 entries";
    if (!isBalanced) return "Debit ≠ Credit";
    return null;
  };

  const createSavePayload = () => ({
    store_id,
    voucher_date: voucherData.voucherDate,
    user_id,
    voucher_type: voucherData.voucherType,
    // voucher_no: voucherData.voucherNo,
    narration: voucherData.narration,
    contra_bank_id: voucherData.contraBank?.account_id || null,
    total_debit: parseFloat(totalDebit.toFixed(2)),
    total_credit: parseFloat(totalCredit.toFixed(2)),
    status: "POSTED",
    created_at: new Date().toISOString(),
    entries: voucherLines.map((line) => ({
      account_id: line.accountId,
      pay_type: line.entryType === "DEBIT" ? "D" : "C",
      amount: parseFloat(line.amount),
      costcentreid: line?.costCentreId,
      entry_narration: line.narration,
      is_contra_entry: line.isContraEntry,
      party_account: line.customerId,
    })),
    fy_id: defaultFYId,
    finance_year: defaultFY,
  });
  const createUpdatePayload = () => ({
    store_id,
    voucher_date: voucherData.voucherDate,
    user_id,
    voucher_type: voucherData.voucherType,
    voucher_no: voucherData.voucherNo, // ← kept for PUT
    narration: voucherData.narration,
    contra_bank_id: voucherData.contraBank?.account_id || null,
    total_debit: parseFloat(totalDebit.toFixed(2)),
    total_credit: parseFloat(totalCredit.toFixed(2)),
    status: "POSTED",
    created_at: new Date().toISOString(),
    entries: voucherLines.map((line) => ({
      account_id: line.accountId,
      pay_type: line.entryType === "DEBIT" ? "D" : "C",
      amount: parseFloat(line.amount),
      costcentreid: line?.costCentreId,
      entry_narration: line.narration,
      is_contra_entry: line.isContraEntry,
      party_account: line.customerId,
    })),
    fy_id: defaultFYId,
    finance_year: defaultFY,
  });

  // const handleSave = async () => {
  //   const validationError = validateVoucher();
  //   if (validationError) {
  //     showSnackbar(validationError, "error");
  //     return;
  //   }

  //   const payload = createSavePayload();

  //   try {
  //     let response;

  //     if (isEditMode && originalVoucherNo) {
  //       response = await axios.put(
  //         `${process.env.REACT_APP_API_BASE_URL}/api/accounts/ledger`,
  //         {
  //           ...payload,
  //           voucherNumber: originalVoucherNo,
  //           updated_at: new Date().toISOString(),
  //         },
  //       );
  //       if (response.data.success)
  //         showSnackbar("✓ Voucher updated successfully!", "success");
  //     } else {
  //       response = await axios.post(
  //         `${process.env.REACT_APP_API_BASE_URL}/api/accounts/ledger`,
  //         payload,
  //       );
  //       if (response.data.success)
  //         showSnackbar("✓ Voucher saved successfully!", "success");
  //     }

  //     if (response.data.success) {
  //       setTimeout(async () => {
  //         const newVoucherNo = await fetchVoucherNumber(
  //           voucherData.voucherType,
  //         );
  //         setVoucherData((prev) => ({ ...prev, voucherNo: newVoucherNo }));
  //         setVoucherLines([]);
  //         setCurrentLine((prev) => ({
  //           entryType:
  //             voucherData.voucherType === "RECEIPT" ? "CREDIT" : "DEBIT",
  //           account: prev.account,
  //           amount: "",
  //           costCentre: null,
  //           narration: "",
  //           customer: null,
  //         }));
  //         setCustomerInputValue("");
  //         setPartyDetails({
  //           code: "",
  //           mobile: "",
  //           name: "",
  //           address: "",
  //           balance: 0,
  //           balanceType: "DEBIT",
  //         });
  //         setErrors({});
  //         setIsHeaderLocked(true);
  //         setIsEditMode(false);
  //         setOriginalVoucherNo(null);
  //         setEditingLineIndex(null);
  //       }, 1500);
  //     } else {
  //       showSnackbar(
  //         response.data.message || "Something went wrong...",
  //         "error",
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error saving voucher:", error);
  //     showSnackbar(
  //       error.response?.data?.message || "Error saving voucher",
  //       "error",
  //     );
  //   }
  // };

  // ==================== DELETE VOUCHER HANDLER ====================

  const handleSave = async () => {
    const validationError = validateVoucher();
    if (validationError) {
      showSnackbar(validationError, "error");
      return;
    }

    try {
      let response;

      if (isEditMode && originalVoucherNo) {
        // ── EDIT: same as before ──
        const payload = createUpdatePayload();
        response = await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/api/accounts/ledger`,
          {
            ...payload,
            voucherNumber: originalVoucherNo,
            updated_at: new Date().toISOString(),
          },
        );
        if (response.data.success) {
          showSnackbar("✓ Voucher updated successfully!", "success");
        }
      } else {
        // ── CREATE: no voucher_no sent, use what backend returns ──
        const payload = createSavePayload();
        response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/accounts/ledger`,
          payload,
        );
        if (response.data.success) {
          const savedVoucherNo = response.data.data.voucher_no;
          setSuccessModal({
            open: true,
            voucherNo: savedVoucherNo,
            voucherType: voucherData.voucherType,
            totalDebit: response.data.data.total_debit,
            totalCredit: response.data.data.total_credit,
            entryCount: response.data.data.entries_created,
          });
          showSnackbar(
            `✓ Voucher ${savedVoucherNo} saved successfully!`,
            "success",
          );
        }
      }

      if (response.data.success) {
        // setTimeout(() => {
        //   // Reset form — no need to fetch a voucher number
        //   setVoucherData((prev) => ({
        //     ...prev,
        //     voucherNo: "", // blank until next save
        //   }));
        //   setVoucherNoInput("");
        //   setVoucherLines([]);
        //   setCurrentLine((prev) => ({
        //     entryType:
        //       voucherData.voucherType === "RECEIPT" ? "CREDIT" : "DEBIT",
        //     account: prev.account,
        //     amount: "",
        //     costCentre: null,
        //     narration: "",
        //     customer: null,
        //   }));
        //   setCustomerInputValue("");
        //   setPartyDetails({
        //     code: "",
        //     mobile: "",
        //     name: "",
        //     address: "",
        //     balance: 0,
        //     balanceType: "DEBIT",
        //   });
        //   setErrors({});
        //   setIsHeaderLocked(true);
        //   setIsEditMode(false);
        //   setOriginalVoucherNo(null);
        //   setEditingLineIndex(null);
        //   setSuccessModal({
        //     open: false,
        //     voucherNo: "",
        //     voucherType: "",
        //     totalDebit: 0,
        //     totalCredit: 0,
        //     entryCount: 0,
        //   });
        //   resetToNew();
        // }, 2000);
        setTimeout(() => {
          // Preserve current date and voucher type
          const currentDate = voucherData.voucherDate;
          const currentType = voucherData.voucherType;

          // Reset everything except date and type
          setVoucherData({
            voucherDate: currentDate,
            voucherType: currentType,
            voucherNo: "",
            narration: "",
            contraBank: null,
          });
          setVoucherNoInput("");
          setVoucherLines([]);
          setCurrentLine({
            entryType: currentType === "RECEIPT" ? "CREDIT" : "DEBIT",
            account: null,
            amount: "",
            costCentre: null,
            narration: "",
            customer: null,
          });
          setAccountCodeInput("");
          setAccountInputValue("");
          setCustomerInputValue("");
          setPartyDetails({
            code: "",
            mobile: "",
            name: "",
            address: "",
            balance: 0,
            balanceType: "DEBIT",
          });
          setErrors({});
          setIsHeaderLocked(true);
          setIsEditMode(false);
          setOriginalVoucherNo(null);
          setEditingLineIndex(null);
          setContraBalance(0);
          setContraBalanceType("DEBIT");
          setAccountBalance(0);
          setAccountBalanceType("DEBIT");
          setSuccessModal({
            open: false,
            voucherNo: "",
            voucherType: "",
            totalDebit: 0,
            totalCredit: 0,
            entryCount: 0,
          });
        }, 2000);
      } else {
        showSnackbar(
          response.data.message || "Something went wrong...",
          "error",
        );
      }
    } catch (error) {
      console.error("Error saving voucher:", error);
      showSnackbar(
        error.response?.data?.message || "Error saving voucher",
        "error",
      );
    }
  };

  const handleDeleteVoucher = () => {
    setDeleteDialog({
      open: true,
      mode: isEditMode ? "api" : "local",
      deleting: false,
    });
  };

  const handleDeleteConfirm = async () => {
    if (deleteDialog.mode === "api") {
      try {
        setDeleteDialog((prev) => ({ ...prev, deleting: true }));

        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/accounts/delete-ledger`,
          { voucherNumber: originalVoucherNo },
        );

        if (response.data.success) {
          showSnackbar(
            `✓ Voucher ${originalVoucherNo} deleted successfully`,
            "success",
          );
          setDeleteDialog({ open: false, mode: null, deleting: false });
          resetToNew();
        } else {
          showSnackbar(
            response.data.message || "Failed to delete voucher",
            "error",
          );
          setDeleteDialog((prev) => ({ ...prev, deleting: false }));
        }
      } catch (error) {
        console.error("Error deleting voucher:", error);
        showSnackbar(
          error.response?.data?.message || "Error deleting voucher",
          "error",
        );
        setDeleteDialog((prev) => ({ ...prev, deleting: false }));
      }
    } else {
      setDeleteDialog({ open: false, mode: null, deleting: false });
      resetToNew();
      showSnackbar("Voucher cleared", "info");
    }
  };

  const resetToNew = () => {
    clearHeaderSession();
    const defaultType = "PAYMENT";
    setVoucherData({
      voucherDate: getTodayDate(),
      voucherType: defaultType,
      voucherNo: "",
      narration: "",
      contraBank: null,
    });
    setVoucherNoInput("");
    setVoucherLines([]);
    setCurrentLine({
      entryType: "DEBIT",
      account: null,
      amount: "",
      costCentre: null,
      narration: "",
      customer: null,
    });
    setAccountCodeInput("");
    setAccountInputValue("");
    setCustomerInputValue("");
    setShowCustomerField(false);
    setErrors({});
    setIsHeaderLocked(false);
    setIsEditMode(false);
    setOriginalVoucherNo(null);
    setEditingLineIndex(null);
    setContraBalance(0);
    setContraBalanceType("DEBIT");
    setAccountBalance(0);
    setAccountBalanceType("DEBIT");
    setPartyDetails({
      code: "",
      mobile: "",
      name: "",
      address: "",
      balance: 0,
      balanceType: "DEBIT",
    });
    // fetchVoucherNumber(defaultType);
  };

  const handleNew = () => {
    resetToNew();
    showSnackbar("New voucher created", "info");
  };

  const handlePrint = () => {
    window.print();
  };

  const handleCreateAccount = (accountName) => {
    goAccounts("/accounts", {
      state: {
        createAccountName: accountName,
        returnPath: inPawn ? "/pawn/accounts-entry" : "/accounts-entry",
      },
    });
  };

  const handleToggleHeaderLock = () => {
    setIsHeaderLocked((prev) => {
      const nowLocked = !prev;
      if (!nowLocked) {
        setVoucherNoInput(voucherData.voucherNo);
        showSnackbar(
          "Voucher No unlocked — type and press Enter to set or load",
          "info",
        );
      }
      return nowLocked;
    });
  };

  const handleVoucherNoClick = async (e) => {
    if (e.key !== "Enter") return;
    const typed = voucherNoInput.trim();
    if (!typed) {
      showSnackbar("Please enter a voucher number", "warning");
      return;
    }
    await fetchVoucherData(typed);
    setVoucherData((prev) => {
      if (!isEditMode) return { ...prev, voucherNo: typed };
      return prev;
    });
  };

  const balDisplay = getBalanceDisplay(
    partyDetails.balance,
    partyDetails.balanceType,
  );
  const accBalDisplay = getBalanceDisplay(accountBalance, accountBalanceType);
  const contraBalDisplay = getBalanceDisplay(contraBalance, contraBalanceType);

  // ==================== KEYBOARD SHORTCUTS ====================
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "F3") {
        e.preventDefault();
        handleDeleteVoucher();
      } else if (e.key === "F4") {
        e.preventDefault();
        handleNew();
      } else if (e.key === "F5") {
        e.preventDefault();
        handleSave();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [voucherLines, voucherData, isEditMode, originalVoucherNo]);

  const handleAccountCodeEnter = (e) => {
    if (e.key !== "Enter") return;
    const code = accountCodeInput.trim().toUpperCase();
    const matchedAccount = accountOptionsWithParty.find(
      (acc) => acc.account_code && acc.account_code.toUpperCase() === code,
    );
    if (matchedAccount) {
      handleAccountSelect(matchedAccount);
      setErrors((prev) => ({ ...prev, account: null }));
    } else {
      setErrors((prev) => ({ ...prev, account: "Invalid code" }));
    }
  };

  // ✅ filteredCostCenters based on acc_nos array
  const filteredCostCenters = useMemo(() => {
    if (!currentLine.account) return [];
    const accountId = currentLine.account.account_id;
    return costCenters.filter((centre) => {
      const accNos = Array.isArray(centre.acc_nos) ? centre.acc_nos : [];
      return accNos.includes(accountId);
    });
  }, [costCenters, currentLine.account]);

  const currentYear = new Date().getFullYear();
  const fiscalYear = `FY ${currentYear - 1}-${String(currentYear).slice(-2)}`;

  const handleBack = () => {
    if (isFromLedger) {
      goAccounts("/accounts-ledger", {
        state: {
          fromAccountsEntry: true,
          // Echoed straight back: the pawn ledger screen uses it to reopen the
          // report chip the drill-down started from.
          ledgerType: location.state?.ledgerType || null,
          highlightVoucher: location.state?.voucher_no,
          reopenDialog: location.state?.reopenDialog || false,
          dialogPartyId: location.state?.dialogPartyId || null,
          dialogAccountId: location.state?.dialogAccountId || null,
        },
      });
    } else {
      navigate(-1);
    }
  };

  // ==================== RENDER ====================
  // Held in a const rather than returned inline: wrapping it in JSX below would
  // otherwise re-indent this whole (very long) tree.
  const content = (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 5,
        maxWidth: 1400,
        margin: "0 auto",
        mt: 1,
        bgcolor: "#f1f5f9",
      }}
    >
      {/* ── GRADIENT HEADER BAR ── */}
      <Box
        sx={{
          // Pawn hosts get the module's blue; the Travel/Daily Tick hosts keep
          // the original navy→cyan gradient.
          background: inPawn
            ? "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)"
            : "linear-gradient(135deg, #1e3a8a 0%, #0891b2 100%)",
          px: 3,
          py: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "16px 16px 0 0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            onClick={handleBack}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              borderRadius: 2,
              bgcolor: "#ffffff2f",
              p: 0.5,
            }}
          >
            <ArrowBackRoundedIcon sx={{ fill: "#FFF" }} />
          </Box>
          <Box
            onClick={goHome}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              borderRadius: 2,
              bgcolor: "#ffffff2f",
              p: 0.5,
            }}
          >
            <HouseIcon sx={{ fill: "#FFF" }} />
          </Box>
          <Typography
            variant="h5"
            sx={{ color: "#fff", fontWeight: 700, letterSpacing: 0.5 }}
          >
            Voucher Entry
          </Typography>{" "}
        </Box>
        <Typography
          variant="body2"
          sx={{ color: "rgba(255,255,255,0.85)", fontWeight: 500 }}
        >
          Accounting Period:{" "}
          <span style={{ fontWeight: 600 }}>
            {" "}
            {defaultFY}-{defaultFY + 1}
          </span>
        </Typography>
      </Box>

      {/* ── MAIN CARD ── */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "0 0 16px 16px",
          border: "1px solid #e2e8f0",
          borderTop: "none",
          overflow: "hidden",
        }}
      >
        {/* ════════ ROW 1 — Date | Type | Contra | Voucher No | icons ════════ */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            px: 2.5,
            py: 1.75,
            bgcolor: "#fff",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          {/* Date */}
          <TextField
            label="Date"
            type="date"
            value={voucherData.voucherDate}
            onChange={(e) => handleVoucherChange("voucherDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
            size="small"
            sx={{ width: 155 }}
          />

          {/* Type */}
          <FormControl size="small" sx={{ width: 155 }}>
            <InputLabel>Type</InputLabel>
            <Select
              value={voucherData.voucherType}
              label="Type"
              onChange={(e) =>
                handleVoucherChange("voucherType", e.target.value)
              }
            >
              <MenuItem value="PAYMENT">PAYMENT</MenuItem>
              <MenuItem value="RECEIPT">RECEIPT</MenuItem>
              <MenuItem value="JOURNAL">JOURNAL</MenuItem>
              <MenuItem value="CONTRA">CONTRA</MenuItem>
            </Select>
          </FormControl>

          {/* Contra Bank + balance badge */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Autocomplete
              options={[
                { account_id: null, account_name: "None" },
                ...bankAccounts,
              ]}
              getOptionLabel={(option) => option.account_name || ""}
              value={
                voucherData.contraBank || {
                  account_id: null,
                  account_name: "None",
                }
              }
              onChange={(e, newValue) =>
                handleVoucherChange(
                  "contraBank",
                  newValue?.account_id ? newValue : null,
                )
              }
              renderInput={(params) => (
                <TextField {...params} label="Contra" size="small" />
              )}
              isOptionEqualToValue={(option, value) =>
                option.account_id === value?.account_id
              }
              sx={{ width: 250 }}
            />
          </Box>

          {/* Voucher No */}
          <TextField
            label="Voucher No"
            value={isHeaderLocked ? voucherData.voucherNo : voucherNoInput}
            onChange={(e) =>
              !isHeaderLocked && setVoucherNoInput(e.target.value)
            }
            onKeyDown={handleVoucherNoClick}
            InputProps={{
              readOnly: isHeaderLocked,
              endAdornment: loadingVoucher ? (
                <InputAdornment position="end">
                  <CircularProgress size={20} />
                </InputAdornment>
              ) : null,
            }}
            disabled={isHeaderLocked}
            size="small"
            placeholder="Type voucher no and press Enter..."
            sx={{
              width: 220,
              bgcolor: isHeaderLocked ? "#f8fafc" : "#fff",
              "& .MuiInputBase-root": {
                bgcolor: isHeaderLocked ? "#f1f5f9" : "#fff",
              },
            }}
          />
          {voucherData.contraBank && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                px: 1.5,
                py: 0.5,
                bgcolor: "#f0f9ff",
                border: "1px solid #bae6fd",
                borderRadius: 2,
                whiteSpace: "nowrap",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#64748b",
                  fontWeight: 500,
                  fontSize: "0.78rem",
                }}
              >
                Bal:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 700,
                  fontSize: "0.82rem",
                  color: contraBalDisplay.color,
                }}
              >
                {contraBalDisplay.text}
              </Typography>
            </Box>
          )}
          <Box sx={{ flex: 1 }} />

          {/* Eye icon */}
          <IconButton
            size="small"
            sx={{ border: "1px solid #e2e8f0", borderRadius: 1.5, p: 0.75 }}
          >
            <VisibilityIcon fontSize="small" sx={{ color: "#64748b" }} />
          </IconButton>

          {/* Pencil / Lock Icon */}
          <Tooltip
            title={
              isHeaderLocked
                ? "Click to edit Voucher No"
                : "Click to lock Voucher No"
            }
          >
            <IconButton
              size="small"
              onClick={handleToggleHeaderLock}
              sx={{
                border: `1.5px solid ${isHeaderLocked ? "#e2e8f0" : "#0891b2"}`,
                borderRadius: 1.5,
                p: 0.75,
                bgcolor: isHeaderLocked ? "transparent" : "#e0f2fe",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: isHeaderLocked ? "#f1f5f9" : "#bae6fd",
                },
              }}
            >
              {isHeaderLocked ? (
                <EditIcon fontSize="small" sx={{ color: "#64748b" }} />
              ) : (
                <LockOpenIcon fontSize="small" sx={{ color: "#0891b2" }} />
              )}
            </IconButton>
          </Tooltip>

          {/* Edit Mode Indicator */}
          {isEditMode && (
            <Chip
              icon={<EditIcon sx={{ fontSize: "0.75rem !important" }} />}
              label={`Editing: ${originalVoucherNo}`}
              size="small"
              sx={{
                height: 22,
                fontSize: "0.68rem",
                bgcolor: "#fef3c7",
                color: "#92400e",
                border: "1px solid #fbbf24",
                "& .MuiChip-icon": { color: "#b45309" },
              }}
            />
          )}

          {/* Locked indicator badge */}
          {isHeaderLocked && !isEditMode && (
            <Chip
              icon={<LockIcon sx={{ fontSize: "0.75rem !important" }} />}
              label="Locked"
              size="small"
              sx={{
                height: 22,
                fontSize: "0.68rem",
                bgcolor: "#f1f5f9",
                color: "#64748b",
                border: "1px solid #e2e8f0",
                "& .MuiChip-icon": { color: "#94a3b8" },
              }}
            />
          )}
        </Box>

        {/* ════════ ROW 2 — Account Code | Account Name | party/balance fields ════════ */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            px: 2.5,
            py: 1.75,
            bgcolor: "#fff",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          {/* Account Code */}
          <TextField
            label="Account Code"
            size="small"
            value={accountCodeInput}
            onChange={(e) => setAccountCodeInput(e.target.value)}
            onKeyDown={handleAccountCodeEnter}
            placeholder="6001"
            error={!!errors.account}
            sx={{ width: 130, flexShrink: 0 }}
          />

          {/* Account Name */}
          <Autocomplete
            ListboxProps={{
              sx: {
                maxHeight: 300,
                overflowY: "auto",
                "&::-webkit-scrollbar": { width: 0 },
                scrollbarWidth: "none",
              },
            }}
            options={accountOptionsWithParty}
            getOptionLabel={(option) =>
              `${option.account_code ? option.account_code + " - " : ""}${
                option.account_name
              }`
            }
            value={currentLine.account}
            inputValue={accountInputValue}
            onInputChange={(e, newInputValue) =>
              setAccountInputValue(newInputValue)
            }
            onChange={(e, newValue) => handleAccountSelect(newValue)}
            filterOptions={(options, params) => {
              const filtered = options.filter((option) => {
                const searchStr = params.inputValue.toLowerCase();
                const accountName = option.account_name.toLowerCase();
                const accountCode = (option.account_code || "").toLowerCase();
                return (
                  accountName.includes(searchStr) ||
                  accountCode.includes(searchStr)
                );
              });
              if (params.inputValue !== "" && filtered.length === 0) {
                return [
                  { isCreateOption: true, account_name: params.inputValue },
                ];
              }
              return filtered;
            }}
            renderOption={(props, option) => {
              if (option.isCreateOption) {
                return (
                  <ListItem
                    {...props}
                    key="create-new"
                    onClick={() => handleCreateAccount(option.account_name)}
                  >
                    <ListItemIcon>
                      <AddCircleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={`Create "${option.account_name}"`}
                      primaryTypographyProps={{
                        color: "primary",
                        fontWeight: 500,
                      }}
                    />
                  </ListItem>
                );
              }
              return (
                <li {...props}>
                  {option.isParty && (
                    <Chip
                      label="PARTY"
                      size="small"
                      color="primary"
                      sx={{ mr: 1, height: 20 }}
                    />
                  )}
                  {`${
                    option.account_code ? option.account_code + " - " : ""
                  }${option.account_name}`}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Account Name"
                error={!!errors.account}
                helperText={errors.account}
                size="small"
              />
            )}
            loading={loading}
            freeSolo={false}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            sx={{ width: 230, flexShrink: 0 }}
          />

          {/* NON-PARTY: inline balance */}
          {currentLine.account && !showCustomerField && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 0.6,
                bgcolor: "#f0f9ff",
                border: "1px solid #bae6fd",
                borderRadius: 2,
                flexShrink: 0,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#64748b",
                  fontWeight: 500,
                  fontSize: "0.78rem",
                  whiteSpace: "nowrap",
                }}
              >
                Balance:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 700,
                  fontSize: "0.82rem",
                  color: accBalDisplay.color,
                  whiteSpace: "nowrap",
                }}
              >
                {accBalDisplay.text}
              </Typography>
            </Box>
          )}

          {/* PARTY FIELDS */}
          {showCustomerField && (
            <Box
              sx={{
                display: "flex",
                gap: 1.5,
                flex: 1,
                alignItems: "center",
                minWidth: 0,
              }}
            >
              {/* Party Code */}
              <TextField
                label="Party Code"
                size="small"
                value={partyDetails.code}
                onChange={(e) =>
                  setPartyDetails((prev) => ({
                    ...prev,
                    code: e.target.value,
                  }))
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    fetchCustomerByPartyCode(partyDetails.code);
                  }
                }}
                placeholder="P001"
                InputProps={{
                  endAdornment: loadingCustomers ? (
                    <InputAdornment position="end">
                      <CircularProgress color="inherit" size={16} />
                    </InputAdornment>
                  ) : null,
                }}
                sx={{ width: 120, flexShrink: 0 }}
              />

              {/* Mobile */}
              <Autocomplete
                options={customerOptions}
                getOptionLabel={(option) => option.mobile || ""}
                value={currentLine.customer}
                inputValue={partyDetails.mobile}
                loading={loadingCustomers}
                onInputChange={(e, value) => {
                  setPartyDetails((prev) => ({ ...prev, mobile: value }));
                  if (value.trim().length >= 3)
                    fetchCustomersByMobile(value.trim());
                  else setCustomerOptions([]);
                }}
                onChange={(e, newValue) => {
                  if (newValue) {
                    handleLineChange("customer", newValue);
                    setErrors((prev) => ({ ...prev, customer: null }));
                    setCustomerInputValue(newValue.name || "");
                    setPartyDetails({
                      code: newValue.party_code || "",
                      mobile: newValue.mobile || "",
                      name: newValue.name || "",
                      address: newValue.address || "",
                      balance: newValue.balance || 0,
                      balanceType: newValue.balanceType || "DEBIT",
                    });
                    fetchBalance(newValue.id, "customer", "party");
                  }
                }}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <PersonIcon fontSize="small" color="action" />
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {option.mobile}
                          {option.whatsapp &&
                            option.whatsapp !== option.mobile && (
                              <Chip
                                label="WA"
                                size="small"
                                color="success"
                                sx={{
                                  ml: 1,
                                  height: 16,
                                  fontSize: "0.65rem",
                                }}
                              />
                            )}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {option.name}
                          {option.company_name && ` • ${option.company_name}`}
                        </Typography>
                        {option.matched_related_mobiles?.map((rel, i) => (
                          <Typography
                            key={i}
                            variant="caption"
                            color="text.secondary"
                            display="block"
                          >
                            {rel.relation}: {rel.number}
                          </Typography>
                        ))}
                        {option.address && (
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            display="block"
                          >
                            📍 {option.address}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Mobile"
                    size="small"
                    placeholder="Type 3+ digits..."
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingCustomers ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                noOptionsText={
                  partyDetails.mobile.length < 3
                    ? "Type at least 3 digits"
                    : loadingCustomers
                      ? "Searching..."
                      : "No customers found"
                }
                filterOptions={(x) => x}
                freeSolo
                sx={{ flex: 1, minWidth: 160 }}
              />

              {/* Search Party */}
              <Autocomplete
                options={customerOptions}
                getOptionLabel={(option) => `${option.name} - ${option.mobile}`}
                value={currentLine.customer}
                inputValue={customerInputValue}
                loading={loadingCustomers}
                onInputChange={(e, value) => {
                  setCustomerInputValue(value);
                  searchCustomers(value);
                }}
                onChange={(e, newValue) => {
                  handleLineChange("customer", newValue);
                  setErrors((prev) => ({ ...prev, customer: null }));
                  if (newValue) {
                    setPartyDetails({
                      code: newValue.party_code || "",
                      mobile: newValue.mobile || "",
                      name: newValue.name || "",
                      address: newValue.address || "",
                      balance: 0,
                      balanceType: "DEBIT",
                    });
                    fetchBalance(newValue.id, "customer", "party");
                  }
                }}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <PersonIcon fontSize="small" color="action" />
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {option.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {option.mobile}
                          {option.company_name && ` • ${option.company_name}`}
                        </Typography>
                        {option.address && (
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            display="block"
                          >
                            📍 {option.address}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Party"
                    size="small"
                    error={!!errors.customer}
                    helperText={errors.customer}
                    placeholder="Type name or mobile..."
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingCustomers ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                          <InputAdornment position="end">
                            <SearchIcon
                              fontSize="small"
                              sx={{ color: "#94a3b8" }}
                            />
                          </InputAdornment>
                        </>
                      ),
                    }}
                  />
                )}
                noOptionsText={
                  customerInputValue.length < 2
                    ? "Type at least 3 characters"
                    : loadingCustomers
                      ? "Searching..."
                      : "No customers found"
                }
                filterOptions={(x) => x}
                sx={{ flex: 1.4, minWidth: 200 }}
              />
            </Box>
          )}
        </Box>

        {/* ════════ INFO BAR — only for PARTY ════════ */}
        <Collapse
          in={showCustomerField && !!currentLine.account}
          timeout="auto"
          unmountOnExit
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              px: 2.5,
              py: 0.9,
              bgcolor: "#f8fafc",
              borderBottom: "1px solid #e2e8f0",
              gap: 0,
              flexWrap: "wrap",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, pr: 2.5 }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#64748b", fontWeight: 500, fontSize: "0.8rem" }}
              >
                Account Balance:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 700,
                  fontSize: "0.85rem",
                  color: accBalDisplay.color,
                }}
              >
                {accBalDisplay.text}
              </Typography>
            </Box>

            {currentLine.customer && (
              <>
                {partyDetails.address && (
                  <>
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ mx: 2, borderColor: "#e2e8f0" }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        pr: 2.5,
                      }}
                    >
                      <LocationOnIcon
                        sx={{ fontSize: "0.9rem", color: "#94a3b8" }}
                      />
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.8rem", color: "#475569" }}
                      >
                        {partyDetails.address}
                      </Typography>
                    </Box>
                  </>
                )}

                {partyDetails.mobile && (
                  <>
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ mx: 2, borderColor: "#e2e8f0" }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        pr: 2.5,
                      }}
                    >
                      <PhoneIcon
                        sx={{ fontSize: "0.9rem", color: "#94a3b8" }}
                      />
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.8rem", color: "#475569" }}
                      >
                        {partyDetails.mobile}
                      </Typography>
                    </Box>
                  </>
                )}

                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ mx: 2, borderColor: "#e2e8f0" }}
                />
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#64748b",
                      fontWeight: 500,
                      fontSize: "0.8rem",
                    }}
                  >
                    Party Balance:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.85rem",
                      color: balDisplay.color,
                    }}
                  >
                    {balDisplay.text}
                  </Typography>
                </Box>
              </>
            )}
          </Box>
        </Collapse>

        {/* ════════ ROW 3 — Amount | Dr/Cr | Cost Centre | Narration | + Add ════════ */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.5,
            px: 2.5,
            py: 1.75,
            bgcolor: "#fff",
          }}
        >
          {/* Amount */}
          <TextField
            label="Amount"
            type="number"
            value={currentLine.amount}
            onChange={(e) => handleLineChange("amount", e.target.value)}
            error={!!errors.amount}
            helperText={errors.amount}
            size="small"
            inputProps={{ step: "0.01", min: "0" }}
            sx={{ width: 150, flexShrink: 0 }}
          />

          {/* Dr/Cr */}
          <FormControl size="small" sx={{ width: 120, flexShrink: 0 }}>
            <InputLabel>Db/Cr</InputLabel>
            <Select
              value={currentLine.entryType}
              label="Db/Cr"
              onChange={(e) => handleLineChange("entryType", e.target.value)}
            >
              <MenuItem value="DEBIT">Db</MenuItem>
              <MenuItem value="CREDIT">Cr</MenuItem>
            </Select>
          </FormControl>

          {/* Cost Centre – filtered by acc_nos */}
          <Autocomplete
            options={filteredCostCenters}
            disabled={!currentLine.account}
            getOptionLabel={(option) => option.name || ""}
            value={currentLine.costCentre}
            onChange={(e, newValue) => handleLineChange("costCentre", newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Cost Centre"
                size="small"
                placeholder="Select Centre"
              />
            )}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            sx={{ width: 190, flexShrink: 0 }}
          />

          {/* Narration */}
          <TextField
            label="Narration"
            value={currentLine.narration}
            onChange={(e) => handleLineChange("narration", e.target.value)}
            size="small"
            placeholder="Enter narration..."
            sx={{ flex: 1, minWidth: 0 }}
          />

          {/* Add / Update Line Button */}
          <Button
            variant="contained"
            onClick={addLineToGrid}
            startIcon={editingLineIndex !== null ? <EditIcon /> : <AddIcon />}
            sx={{
              height: 40,
              px: 3,
              flexShrink: 0,
              background:
                editingLineIndex !== null
                  ? "linear-gradient(135deg, #b45309 0%, #d97706 100%)"
                  : "linear-gradient(135deg, #1e3a8a 0%, #0891b2 100%)",
              "&:hover": {
                background:
                  editingLineIndex !== null
                    ? "linear-gradient(135deg, #92400e 0%, #b45309 100%)"
                    : "linear-gradient(135deg, #1e40af 0%, #0e7490 100%)",
              },
              borderRadius: 2,
              fontWeight: 600,
              textTransform: "none",
              whiteSpace: "nowrap",
            }}
          >
            {editingLineIndex !== null ? "Update Line" : "Add"}
          </Button>
        </Box>

        <Divider sx={{ mx: 2.5, borderColor: "#e2e8f0" }} />

        {/* ════════ ENTRIES TABLE ════════ */}
        <TableContainer sx={{ maxHeight: 320, mt: 1.5 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {[
                  "Sl",
                  "Code",
                  "Account",
                  "Customer",
                  "Debit",
                  "Credit",
                  "Centre",
                  "Narration",
                  "Del",
                ].map((col) => (
                  <TableCell
                    key={col}
                    align={["Debit", "Credit"].includes(col) ? "right" : "left"}
                    sx={{
                      bgcolor: "#1e3a8a",
                      color: "white",
                      py: 0.75,
                      fontSize: "0.78rem",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {voucherLines.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={9}
                    align="center"
                    sx={{ py: 4, color: "#94a3b8", fontSize: "0.85rem" }}
                  >
                    No entries yet. Add your first entry above ↑
                  </TableCell>
                </TableRow>
              ) : (
                voucherLines.map((line, index) => (
                  <TableRow
                    key={index}
                    onClick={() => handleRowClick(line, index)}
                    sx={{
                      cursor: line.isContraEntry ? "default" : "pointer",
                      "&:hover": {
                        bgcolor: line.isContraEntry ? "#f0fdf4" : "#e0f2fe",
                      },
                      bgcolor:
                        editingLineIndex === index
                          ? "#bae6fd !important"
                          : line.isContraEntry
                            ? "#f0fdf4"
                            : line.entryType === "DEBIT"
                              ? "#fffbeb"
                              : "#eff6ff",
                      outline:
                        editingLineIndex === index
                          ? "2px solid #0891b2"
                          : "none",
                    }}
                  >
                    <TableCell sx={{ py: 0.5, fontSize: "0.8rem" }}>
                      {line.slNo}
                      {line.isContraEntry && (
                        <Chip
                          label="C"
                          size="small"
                          color="success"
                          sx={{ ml: 0.5, height: 16, fontSize: "0.65rem" }}
                        />
                      )}
                    </TableCell>
                    <TableCell sx={{ py: 0.5, fontSize: "0.8rem" }}>
                      {line.accountCode || "-"}
                    </TableCell>
                    <TableCell sx={{ py: 0.5, fontSize: "0.8rem" }}>
                      {line.accountName}
                    </TableCell>
                    <TableCell sx={{ py: 0.5, fontSize: "0.75rem" }}>
                      {line.customerName ? (
                        <Box>
                          <Typography
                            variant="caption"
                            sx={{ fontWeight: 500 }}
                          >
                            {line.customerName}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            display="block"
                          >
                            {line.customerMobile}
                          </Typography>
                        </Box>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ py: 0.5, fontSize: "0.8rem", fontWeight: 500 }}
                    >
                      {line.entryType === "DEBIT"
                        ? formatCurrency(line.amount)
                        : "-"}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ py: 0.5, fontSize: "0.8rem", fontWeight: 500 }}
                    >
                      {line.entryType === "CREDIT"
                        ? formatCurrency(line.amount)
                        : "-"}
                    </TableCell>
                    {/* ✅ FIXED: display cost centre name, not ID */}
                    <TableCell sx={{ py: 0.5, fontSize: "0.75rem" }}>
                      {line.costCentreName || line.costCentreId || "-"}
                    </TableCell>
                    <TableCell sx={{ py: 0.5, fontSize: "0.75rem" }}>
                      {line.narration || "-"}
                    </TableCell>
                    <TableCell sx={{ py: 0.5 }}>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteLineFromGrid(index);
                        }}
                        disabled={line.isContraEntry}
                      >
                        <DeleteIcon sx={{ fontSize: "1rem" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ════════ FOOTER — Totals + Action Buttons ════════ */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: 1.25,
            bgcolor: "#f8fafc",
            borderTop: "1px solid #e2e8f0",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {/* Totals */}
          <Box sx={{ display: "flex", gap: 3 }}>
            <Typography
              variant="body2"
              sx={{ color: "#64748b", fontSize: "0.8rem" }}
            >
              Total Debit:{" "}
              <Box component="span" sx={{ fontWeight: 700, color: "#dc2626" }}>
                ₹{formatCurrency(totalDebit)}
              </Box>
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#64748b", fontSize: "0.8rem" }}
            >
              Total Credit:{" "}
              <Box component="span" sx={{ fontWeight: 700, color: "#16a34a" }}>
                ₹{formatCurrency(totalCredit)}
              </Box>
            </Typography>
            {voucherLines.length > 0 && !isBalanced && (
              <Typography
                variant="body2"
                sx={{ color: "#dc2626", fontWeight: 600, fontSize: "0.8rem" }}
              >
                Diff: ₹{formatCurrency(Math.abs(difference))}
              </Typography>
            )}
            {voucherLines.length >= 2 && isBalanced && (
              <Chip
                label="✓ Balanced"
                size="small"
                color="success"
                sx={{ height: 20, fontSize: "0.7rem" }}
              />
            )}
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<NewIcon />}
              onClick={handleNew}
              sx={{ textTransform: "none" }}
            >
              New
            </Button>
            <Button
              variant="outlined"
              size="small"
              color="error"
              startIcon={<DeleteForeverIcon />}
              onClick={handleDeleteVoucher}
              sx={{ textTransform: "none" }}
            >
              Delete
            </Button>
            <Button
              variant="outlined"
              size="small"
              startIcon={<PrintIcon />}
              onClick={handlePrint}
              sx={{ textTransform: "none" }}
            >
              Print
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={<SaveIcon />}
              onClick={handleSave}
              disabled={!isBalanced || voucherLines.length < 2}
              sx={{
                textTransform: "none",
                background: isEditMode
                  ? "linear-gradient(135deg, #b45309 0%, #d97706 100%)"
                  : "linear-gradient(135deg, #1e3a8a 0%, #0891b2 100%)",
                "&:hover": {
                  background: isEditMode
                    ? "linear-gradient(135deg, #92400e 0%, #b45309 100%)"
                    : "linear-gradient(135deg, #1e40af 0%, #0e7490 100%)",
                },
                "&.Mui-disabled": { opacity: 0.5 },
              }}
            >
              {isEditMode ? "Update" : "Save"}
            </Button>
          </Box>
        </Box>
      </Paper>

      {/* ════════ DELETE CONFIRMATION DIALOG ════════ */}
      <Dialog
        open={deleteDialog.open}
        onClose={() =>
          !deleteDialog.deleting &&
          setDeleteDialog({ open: false, mode: null, deleting: false })
        }
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            pb: 1,
            color: deleteDialog.mode === "api" ? "#dc2626" : "#b45309",
          }}
        >
          <WarningIcon
            sx={{
              color: deleteDialog.mode === "api" ? "#dc2626" : "#d97706",
            }}
          />
          {deleteDialog.mode === "api" ? "Delete Voucher" : "Discard Changes"}
        </DialogTitle>

        <DialogContent sx={{ pt: 0 }}>
          {deleteDialog.mode === "api" ? (
            <DialogContentText>
              Are you sure you want to permanently delete voucher{" "}
              <Box component="span" sx={{ fontWeight: 700, color: "#1e3a8a" }}>
                {originalVoucherNo}
              </Box>
              ? This action{" "}
              <Box component="span" sx={{ fontWeight: 700, color: "#dc2626" }}>
                cannot be undone
              </Box>{" "}
              and all ledger entries will be removed.
            </DialogContentText>
          ) : (
            <DialogContentText>
              You have unsaved entries in this voucher. Are you sure you want to
              discard all changes? All data entered will be{" "}
              <Box component="span" sx={{ fontWeight: 700, color: "#b45309" }}>
                lost
              </Box>
              .
            </DialogContentText>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button
            onClick={() =>
              setDeleteDialog({ open: false, mode: null, deleting: false })
            }
            disabled={deleteDialog.deleting}
            variant="outlined"
            size="small"
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            disabled={deleteDialog.deleting}
            variant="contained"
            size="small"
            color="error"
            startIcon={
              deleteDialog.deleting ? (
                <CircularProgress size={14} color="inherit" />
              ) : (
                <DeleteForeverIcon />
              )
            }
            sx={{ textTransform: "none", minWidth: 110 }}
          >
            {deleteDialog.deleting
              ? "Deleting..."
              : deleteDialog.mode === "api"
                ? "Yes, Delete"
                : "Yes, Discard"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── CONFIRMATION DIALOG (type / contra change) ── */}
      <Dialog
        open={confirmDialog.open}
        onClose={() => handleConfirmDialogClose(false)}
      >
        <DialogTitle>Confirm Change</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You have existing entries. Changing the{" "}
            {confirmDialog.field === "voucherType"
              ? "voucher type"
              : "contra bank"}{" "}
            will clear all entries. Do you want to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleConfirmDialogClose(false)}>
            Cancel
          </Button>
          <Button
            onClick={() => handleConfirmDialogClose(true)}
            color="error"
            variant="contained"
          >
            Clear & Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── SNACKBAR ── */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* ════════ SUCCESS MODAL ════════ */}
      <Dialog
        open={successModal.open}
        PaperProps={{
          sx: {
            borderRadius: 3,
            minWidth: 340,
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          },
        }}
      >
        {/* Green top bar */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #165fa3 0%, #165fa3 100%)",
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              bgcolor: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.1rem",
            }}
          >
            ✓
          </Box>
          <Box>
            <Typography
              variant="subtitle1"
              sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.2 }}
            >
              Voucher Created
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "rgba(255,255,255,0.8)" }}
            >
              Entry saved successfully
            </Typography>
          </Box>
        </Box>

        <DialogContent sx={{ px: 3, py: 2.5 }}>
          {/* Voucher number pill */}
          <Box
            sx={{
              bgcolor: "#f0fdf4",
              border: "1px solid #bbf7d0",
              borderRadius: 2,
              px: 2,
              py: 1.25,
              mb: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: "#15803d", fontWeight: 500, fontSize: "0.8rem" }}
            >
              Voucher No
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "#14532d", fontWeight: 700, fontSize: "1rem" }}
            >
              {successModal.voucherNo}
            </Typography>
          </Box>

          {/* Details grid */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="body2"
                sx={{ color: "#64748b", fontSize: "0.8rem" }}
              >
                Type
              </Typography>
              <Chip
                label={successModal.voucherType}
                size="small"
                sx={{
                  height: 20,
                  fontSize: "0.68rem",
                  fontWeight: 600,
                  bgcolor: "#dbeafe",
                  color: "#1e40af",
                }}
              />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="body2"
                sx={{ color: "#64748b", fontSize: "0.8rem" }}
              >
                Total Debit
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#dc2626",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                }}
              >
                ₹{formatCurrency(successModal.totalDebit)}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="body2"
                sx={{ color: "#64748b", fontSize: "0.8rem" }}
              >
                Total Credit
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#16a34a",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                }}
              >
                ₹{formatCurrency(successModal.totalCredit)}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="body2"
                sx={{ color: "#64748b", fontSize: "0.8rem" }}
              >
                Entries
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#475569",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                }}
              >
                {successModal.entryCount} lines
              </Typography>
            </Box>
          </Box>

          {/* Auto-close progress bar */}
          <Box
            sx={{
              mt: 2.5,
              height: 3,
              bgcolor: "#e2e8f0",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                height: "100%",
                bgcolor: "#165fa3",
                borderRadius: 2,
                animation: successModal.open
                  ? "shrink 2s linear forwards"
                  : "none",
                "@keyframes shrink": {
                  from: { width: "100%" },
                  to: { width: "0%" },
                },
              }}
            />
          </Box>
          <Typography
            variant="caption"
            sx={{
              color: "#94a3b8",
              fontSize: "0.72rem",
              display: "block",
              textAlign: "center",
              mt: 0.5,
            }}
          >
            Closing automatically…
          </Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );

  return <PawnAccountsSkin active={inPawn}>{content}</PawnAccountsSkin>;
};

export default AccountEntry;
